"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[82583],{

/***/ 13946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$A": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_IMAGE; },
/* harmony export */   "BC": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_TITLE; },
/* harmony export */   "BO": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_DOCUMENT_ATTACHMENT; },
/* harmony export */   "Ct": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_BTN; },
/* harmony export */   "Df": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_USERNAME; },
/* harmony export */   "EI": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_SYMBOL_NAME; },
/* harmony export */   "Fu": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT_READ_MORE; },
/* harmony export */   "Gd": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_COVER; },
/* harmony export */   "IF": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION; },
/* harmony export */   "O4": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_AVATAR; },
/* harmony export */   "OH": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_AGREE_BTN; },
/* harmony export */   "PZ": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX; },
/* harmony export */   "Pu": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_TITLE; },
/* harmony export */   "Q_": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS; },
/* harmony export */   "S6": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT; },
/* harmony export */   "WS": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_IMAGE; },
/* harmony export */   "Wc": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT; },
/* harmony export */   "YE": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_HEADER; },
/* harmony export */   "Yu": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT; },
/* harmony export */   "aQ": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_DISAGREE_BTN; },
/* harmony export */   "cB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_TITLE; },
/* harmony export */   "dL": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_NEWS_SOURCE; },
/* harmony export */   "dS": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING; },
/* harmony export */   "dv": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_PERCENTAGE; },
/* harmony export */   "ey": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_ICON; },
/* harmony export */   "fS": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_INITIAL_PRICE; },
/* harmony export */   "g4": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TIMING; },
/* harmony export */   "kc": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_PDF; },
/* harmony export */   "ks": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_UNAVAILABLE; },
/* harmony export */   "ld": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_TITLE; },
/* harmony export */   "m0": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_TOTAL_VOTERS; },
/* harmony export */   "mL": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_LABEL; },
/* harmony export */   "nJ": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_FILENAME; },
/* harmony export */   "ny": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_INDEX; },
/* harmony export */   "ov": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_YOUTUBE_PLAYER; },
/* harmony export */   "oz": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE; },
/* harmony export */   "qS": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_PLAY_BTN; },
/* harmony export */   "ry": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_ICON; },
/* harmony export */   "s_": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TARGET_PRICE; },
/* harmony export */   "to": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_FEED_LABEL; },
/* harmony export */   "tz": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_IMAGE; },
/* harmony export */   "wB": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT_CONTENT; },
/* harmony export */   "zP": function() { return /* binding */ DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_CONTENT; }
/* harmony export */ });
/* unused harmony export TEST_CASE_MESSAGE_COMPONENTS */
var TEST_CASE_MESSAGE_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " inside ChatPreview should render successfully")
    };
};
// index ChatPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_INDEX = "chat-page-main-content-chat-preview-index";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_IMAGE = "chat-page-main-content-chat-preview-image";
// HeaderPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_HEADER = "chat-page-main-content-chat-preview-header";
// TextPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT = "chat-page-main-content-chat-preview-text";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_TEXT_READ_MORE = "chat-page-main-content-chat-preview-text-read-more";
// NewsPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS = "chat-page-main-content-chat-preview-news";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_IMAGE = "chat-page-main-content-chat-preview-news-image";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_TITLE = "chat-page-main-content-chat-preview-news-title";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_NEWS_FEED_LABEL = "chat-page-main-content-chat-preview-news-feed-label";
// ReportPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT = "chat-page-main-content-chat-preview-report";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPORT_CONTENT = "chat-page-main-content-chat-preview-report-content";
// PollingPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING = "chat-page-main-content-chat-preview-polling";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_ICON = "chat-page-main-content-chat-preview-polling-icon";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_BTN = "chat-page-main-content-chat-preview-polling-btn";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_POLLING_TOTAL_VOTERS = "chat-page-main-content-chat-preview-polling-total-voters";
// YoutubePreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE = "chat-page-main-content-chat-preview-youtube";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_COVER = "chat-page-main-content-chat-preview-youtube-cover";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_PLAY_BTN = "chat-page-main-content-chat-preview-youtube-play-btn";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_YOUTUBE_TITLE = "chat-page-main-content-chat-preview-youtube-title";
// AttachmentPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT = "chat-page-main-content-chat-preview-attachment";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_TITLE = "chat-page-main-content-chat-preview-attachment-title";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_FILENAME = "chat-page-main-content-chat-preview-attachment-file-name";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_ATTACHMENT_PDF = "chat-page-main-content-chat-preview-attachment-pdf";
// PredictionPreview
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION = "chat-page-main-content-chat-preview-prediction";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_ICON = "chat-page-main-content-chat-preview-prediction-icon";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_LABEL = "chat-page-main-content-chat-preview-prediction-label";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_SYMBOL_NAME = "chat-page-main-content-chat-preview-prediction-symbol-name";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TARGET_PRICE = "chat-page-main-content-chat-preview-prediction-target-price";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_INITIAL_PRICE = "chat-page-main-content-chat-preview-prediction-initial-price";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_PERCENTAGE = "chat-page-main-content-chat-preview-prediction-percentage";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_TIMING = "chat-page-main-content-chat-preview-prediction-timing";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_DISAGREE_BTN = "chat-page-main-content-chat-preview-prediction-disagree-btn";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_PREDICTION_AGREE_BTN = "chat-page-main-content-chat-preview-prediction-agree-btn";
// RepostBox
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX = "chat-page-main-content-chat-preview-repost-box";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_UNAVAILABLE = "chat-page-main-content-chat-preview-repost-box-unavailable";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_AVATAR = "chat-page-main-content-chat-preview-repost-box-avatar";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_USERNAME = "chat-page-main-content-chat-preview-repost-box-username";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_IMAGE = "chat-page-main-content-chat-preview-repost-box-image";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_TITLE = "chat-page-main-content-chat-preview-repost-box-title";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_CONTENT = "chat-page-main-content-chat-preview-repost-box-content";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_YOUTUBE_PLAYER = "chat-page-main-content-chat-preview-repost-box-youtube-player";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_NEWS_SOURCE = "chat-page-main-content-chat-preview-repost-box-news-source";
var DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_DOCUMENT_ATTACHMENT = "chat-page-main-content-chat-preview-repost-box-document-attachment";


/***/ }),

/***/ 71078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(29658);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);






var InfiniteScroll = function(_param) {
    var children = _param.children, hasMore = _param.hasMore, refineNext = _param.refineNext, loader = _param.loader, isLoading = _param.isLoading, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "children",
        "hasMore",
        "refineNext",
        "loader",
        "isLoading"
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), sentinel = ref[0], setSentinel = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), observer = ref1[0], setObserver = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var onSentinelIntersection = function(entries) {
            entries.forEach(function(entry) {
                if (entry.isIntersecting && hasMore) {
                    refineNext();
                }
            });
        };
        if (hasMore) {
            setObserver(new window.IntersectionObserver(onSentinelIntersection));
        }
    }, [
        hasMore,
        refineNext
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (observer && sentinel) {
            observer.observe(sentinel);
        }
        return function() {
            if (observer && sentinel) observer.disconnect();
        };
    }, [
        observer,
        sentinel
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, rest), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                condition: loader && isLoading && hasMore,
                children: loader
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                condition: !isLoading && observer && hasMore,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        display: "inline"
                    },
                    className: "infinite-sentinel",
                    ref: function(c) {
                        return setSentinel(c);
                    }
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InfiniteScroll);


/***/ }),

/***/ 2869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "iO": function() { return /* binding */ ModalText; },
/* harmony export */   "u_": function() { return /* binding */ Modal; },
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20539);
/* harmony import */ var _deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16368);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 3px;\n  height: 44px;\n  &:not(:first-child) {\n    margin-left: 20px !important;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .ant-modal-close-x {\n    display: none;\n  }\n  .ant-modal-content {\n    border-radius: 3px;\n  }\n  .ant-modal-header {\n    padding: 0 20px !important;\n    height: 54px;\n    border-color: ",
        ";\n    border-top-left-radius: 3px;\n    border-top-right-radius: 3px;\n  }\n  .ant-modal-title {\n    p {\n      text-align: center;\n    }\n  }\n  .ant-modal-close-x {\n    & > img {\n      width: 15px;\n      height: 15px;\n    }\n  }\n  .ant-modal-body {\n    padding: 0 20px 20px 20px;\n  }\n  .ant-modal-footer {\n    padding: 20px;\n    text-align: left;\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: pre-wrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var Button = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ade475be-0"
})(_templateObject());
var Modal = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).attrs({
    zIndex: 1031,
    width: 400,
    centered: true
}).withConfig({
    componentId: "sc-ade475be-1"
})(_templateObject1(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].gainsboro */ .Z.gainsboro);
var ModalText = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ade475be-2"
})(_templateObject2());



/***/ }),

/***/ 50700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tN": function() { return /* reexport */ ModalDelete_ModalDeleteAdmin; },
  "c5": function() { return /* reexport */ ModalDelete_ModalDeleteAuthor; },
  "eV": function() { return /* reexport */ Modals_ModalInsight; },
  "gU": function() { return /* reexport */ Modals_ModalLike; },
  "aA": function() { return /* reexport */ Modals_ModalReport; },
  "MW": function() { return /* reexport */ Modals_ModalTipping; }
});

// UNUSED EXPORTS: ModalLinkPost

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var common_Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/hooks/useForm.js
var useForm = __webpack_require__(15077);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var constants = __webpack_require__(21390);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/styled.ts
var styled = __webpack_require__(89784);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalDelete/ModalDeleteAdmin.tsx











function ModalDeleteAdmin(_param) {
    var onDelete = _param.onDelete, onCancel = _param.onCancel, _multiple = _param.multiple, multiple = _multiple === void 0 ? false : _multiple, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "onDelete",
        "onCancel",
        "multiple"
    ]);
    var ref = (0,react.useState)(false), sendEmail = ref[0], setSendEmail = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: constants/* defaultReportLabel */.u3
    }), 2), reason = ref1[0], setReason = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: "1d"
    }), 2), time = ref2[0], setTime = ref2[1];
    var timeRanges = [
        {
            label: "24 Hours Post",
            value: "1d"
        },
        {
            label: "3 Days Post",
            value: "3d"
        },
        {
            label: "7 Days post",
            value: "1w"
        }, 
    ];
    var handleCheck = function() {
        setSendEmail(!sendEmail);
    };
    var handleDelete = function() {
        var data = {
            reason: reason,
            sendEmail: sendEmail
        };
        if (multiple) {
            data.time = time;
        }
        onDelete(data);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
            size: "16px",
            height: "40px",
            family: "bold",
            children: "Delete Stream"
        }),
        centered: true,
        width: 280,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                block: true,
                type: "primary",
                height: "40px",
                onClick: handleDelete,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    color: color/* default.light */.Z.light,
                    children: "Confirm"
                })
            }, "confirm"), 
        ],
        children: [
            multiple && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                        size: "12px",
                        children: "Delete Post For: "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                        value: time,
                        onChange: function(e) {
                            return setTime(e);
                        },
                        children: timeRanges.map(function(param) {
                            var value = param.value, label = param.label;
                            return(// @ts-expect-error
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                                value: value,
                                children: label
                            }, value));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "12px",
                children: "Delete Reason : "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                value: reason,
                onChange: function(e) {
                    return setReason(e);
                },
                children: constants/* reportOptions.map */.c$.map(function(param) {
                    var key = param.key, label = param.label;
                    return(// @ts-expect-error
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                        value: label,
                        children: label
                    }, key));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "12px",
                children: "Send Report to User ? "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "checkbox",
                checked: sendEmail,
                onChange: handleCheck
            })
        ]
    }));
}
/* harmony default export */ var ModalDelete_ModalDeleteAdmin = (ModalDeleteAdmin);

// EXTERNAL MODULE: ./src/constants/data-cy.ts
var data_cy = __webpack_require__(70524);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/ModalDelete/styled.ts
var ModalDelete_styled = __webpack_require__(2869);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalDelete/ModalDeleteAuthor.tsx





var modalTypeInfo = {
    post: {
        title: "Post",
        text: "Are you sure want to delete this post?\nThis action can’t be undone"
    },
    comment: {
        title: "Comment",
        text: "Are you sure want to delete this comment?\nThis action can’t be undone"
    }
};
function ModalDeleteAuthor(param) {
    var onCancel = param.onCancel, visible = param.visible, handleDelete = param.handleDelete, type = param.type;
    var ref, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Modal */.u_, {
        visible: visible,
        onCancel: onCancel,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
            size: "20px",
            height: "54px",
            family: "bold",
            children: [
                "Delete ",
                (ref = modalTypeInfo[type]) === null || ref === void 0 ? void 0 : ref.title
            ]
        }),
        closeIcon: null,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Button */.zx, {
                block: true,
                height: "40px",
                onClick: onCancel,
                "data-cy": data_cy/* default.STREAM_POST.CONFIRM_CANCEL_BUTTON */.Z.STREAM_POST.CONFIRM_CANCEL_BUTTON,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* Button */.zx, {
                block: true,
                type: "secondary",
                height: "40px",
                onClick: handleDelete,
                "data-cy": data_cy/* default.STREAM_POST.CONFIRM_DELETE_BUTTON */.Z.STREAM_POST.CONFIRM_DELETE_BUTTON,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: "Delete"
                })
            }, "confirm"), 
        ],
        transitionName: "",
        maskTransitionName: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalDelete_styled/* ModalText */.iO, {
            size: "14px",
            height: "19px",
            align: "center",
            children: (ref1 = modalTypeInfo[type]) === null || ref1 === void 0 ? void 0 : ref1.text
        })
    });
}
/* harmony default export */ var ModalDelete_ModalDeleteAuthor = (ModalDeleteAuthor);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/ImageSlider/index.tsx + 7 modules
var ImageSlider = __webpack_require__(9649);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
// EXTERNAL MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx + 2 modules
var PollingContainer = __webpack_require__(78690);
// EXTERNAL MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx + 2 modules
var TargetPriceContainer = __webpack_require__(18562);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/DocumentContainer.tsx
var DocumentContainer = __webpack_require__(55424);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/Header.tsx
var Header = __webpack_require__(5373);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx + 1 modules
var TitleContent = __webpack_require__(41447);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalInsight.tsx



















function ModalInsight(_param) {
    var post = _param.post, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "post"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var content = post.content, content_original = post.content_original, images = post.images, attachment = post.attachment, polling = post.polling, target_price = post.target_price, mask_html = post.mask_html, title = post.title, titleurl = post.titleurl, images_data = post.images_data, image_frame_type = post.image_frame_type, analytics = post.analytics, isAuthor = post.is_author;
    var imagesData = (0,react.useMemo)(function() {
        var listImage = (images === null || images === void 0 ? void 0 : images.length) > 0 && images[0] !== "" ? images.map(function(i) {
            return {
                image: i
            };
        }) : [];
        listImage = listImage.filter(function(i) {
            var exist = images_data.find(function(img) {
                return img.image === i.image;
            });
            return !exist;
        });
        listImage = (0,_to_consumable_array/* default */.Z)(listImage).concat((0,_to_consumable_array/* default */.Z)(images_data));
        return listImage;
    }, [
        post
    ]);
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var totalEngagement = (0,react.useMemo)(function() {
        var total = 0;
        if (analytics === null || analytics === void 0 ? void 0 : analytics.engagement) {
            Object.keys(analytics === null || analytics === void 0 ? void 0 : analytics.engagement).forEach(function(key) {
                total += analytics === null || analytics === void 0 ? void 0 : analytics.engagement[key];
            });
        }
        return total;
    }, [
        post
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SModalInsight */.Aq, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
            size: "18px",
            family: "bold",
            align: "center",
            // @ts-expect-error
            pt: "16px",
            children: "Insights"
        }),
        centered: true,
        footer: null,
        width: 800,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InsightWrapper */.Id, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PostInsightContainer */.hS, {
                    id: "post-detail",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* PostInsightFreeze */.SV, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {
                            post: post,
                            isLoggedIn: false,
                            withMenu: false
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* ContentWrapper */.vs, {
                            children: (polling === null || polling === void 0 ? void 0 : polling.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer/* default */.Z, {
                                post: post,
                                isSinglePost: true
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* TextContainer */.lU, {
                                        children: [
                                            title && titleurl && /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent/* default */.Z, {
                                                title: title,
                                                titleUrl: titleurl
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                                content: content,
                                                maskedHtml: mask_html
                                            }),
                                            post.newsfeed_source && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        alt: post.newsfeed_label,
                                                        src: "/".concat(post.newsfeed_img),
                                                        style: {
                                                            width: "16px",
                                                            marginRight: "8px"
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                        size: "12px",
                                                        children: post.newsfeed_label
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isHaveImage ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* default */.Z, {
                                        images: imagesData,
                                        frameType: image_frame_type
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                                        content: content_original
                                    }),
                                    (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentContainer/* default */.Z, {
                                        documents: attachment
                                    }),
                                    (target_price === null || target_price === void 0 ? void 0 : target_price.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(TargetPriceContainer/* default */.Z, {
                                        targetPrice: target_price[0],
                                        postid: post.postid,
                                        isAuthor: isAuthor
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* InsightContainer */.re, {
                    id: "insight-detail",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    size: "22px",
                                    weight: "bold",
                                    children: "Impressions"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    size: "22px",
                                    weight: "bold",
                                    children: (analytics === null || analytics === void 0 ? void 0 : analytics.impressions) || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    size: "22px",
                                    weight: "bold",
                                    children: "Total Engagements"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    size: "22px",
                                    weight: "bold",
                                    children: totalEngagement
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Like"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: (analytics === null || analytics === void 0 ? void 0 : (ref1 = analytics.engagement) === null || ref1 === void 0 ? void 0 : ref1.like) || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Reply"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: (analytics === null || analytics === void 0 ? void 0 : (ref2 = analytics.engagement) === null || ref2 === void 0 ? void 0 : ref2.reply) || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Share"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: (analytics === null || analytics === void 0 ? void 0 : (ref3 = analytics.engagement) === null || ref3 === void 0 ? void 0 : ref3.share) || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Post Clicks"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: (analytics === null || analytics === void 0 ? void 0 : (ref4 = analytics.engagement) === null || ref4 === void 0 ? void 0 : ref4.sign_click) || 0
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            padding: "5px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: "Profile Views"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                    children: (analytics === null || analytics === void 0 ? void 0 : (ref5 = analytics.engagement) === null || ref5 === void 0 ? void 0 : ref5.profile_view) || 0
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
}
/* harmony default export */ var Modals_ModalInsight = (ModalInsight);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./src/global/InfiniteScroll/index.tsx
var InfiniteScroll = __webpack_require__(71078);
// EXTERNAL MODULE: ./src/features/stream/analytics/StreamTabAnalytics.ts
var StreamTabAnalytics = __webpack_require__(99093);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
// EXTERNAL MODULE: ./src/constants/api.js
var api = __webpack_require__(37213);
// EXTERNAL MODULE: ./src/global/Labels/index.tsx + 5 modules
var Labels = __webpack_require__(94493);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/features/user/analytics/ProfileAnalytics.ts
var ProfileAnalytics = __webpack_require__(63576);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var common_Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Input.js
var common_Input = __webpack_require__(54325);
// EXTERNAL MODULE: ./src/@deprecated-ui/company/Modal.js
var company_Modal = __webpack_require__(50550);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/device.js
var device = __webpack_require__(74575);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalLike/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: calc(100vh - 200px);\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 15px;\n  padding-right: 15px;\n  @media ",
        " {\n    padding-left: 50px;\n    padding-right: 50px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 100px) !important;\n  margin: 0 50px;\n  border: 1px solid transparent!important;\n  background: #f9f9f9!important;\n  padding: 6px 7px 6px 14px;\n  border-radius: 10px!important;\n\n  input {\n    background: #f9f9f9!important;\n    height: 30px!important;\n\n    ::placeholder {\n      color: ",
        "",
        "\n      font-weight: bold;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: -20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .ant-modal-close {\n    right: 32px;\n    font-weight: bold;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 16px;\n  margin-right: 5px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}









var UserListContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7547c86e-0"
})(_templateObject());
var UserItemContainer = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center",
    justify: "space-between",
    py: "10px"
}).withConfig({
    componentId: "sc-7547c86e-1"
})(_templateObject1(), device/* default.tablet */.Z.tablet);
var Search = (0,styled_components_browser_esm/* default */.ZP)(common_Input/* default */.Z).withConfig({
    componentId: "sc-7547c86e-2"
})(_templateObject2(), color/* default.black */.Z.black, (0,hexOpacity/* default */.Z)(0.65));
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(common_Iconmoon/* default */.Z).attrs({
    className: "icon-widget_close"
}).withConfig({
    componentId: "sc-7547c86e-3"
})(_templateObject3());
var styled_Modal = (0,styled_components_browser_esm/* default */.ZP)(company_Modal/* default */.Z).withConfig({
    componentId: "sc-7547c86e-4"
})(_templateObject4());
var SearchIcon = (0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).attrs({
    src: "/icon/cari.svg",
    alt: "search-icon"
}).withConfig({
    componentId: "sc-7547c86e-5"
})(_templateObject5());


;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalLike/UserItem.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ 



















var pageSourceIndex = ProfileAnalytics/* PAGE_SOURCE_INDEX.findIndex */.en.findIndex(function(x) {
    return x === "Stream Like List";
});
function UserItem(param) {
    var user = param.user, postid = param.postid, hasButton = param.hasButton;
    var avatar = user.avatar, id = user.id, username = user.username, fullname = user.fullname, followed = user.followed;
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(false), isLoading = ref[0], setIsLoading = ref[1];
    var buttonType = followed ? "default" : "outline-primary";
    var followingText = followed ? "Following" : "Follow";
    var handleFollowUser = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data, follow, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        StreamTabAnalytics/* default.common.Action.clickFollowButton */.ZP.common.Action.clickFollowButton(StreamTabAnalytics/* PAGE_SOURCE.LIKES */.nP.LIKES);
                        data = {
                            postid: postid,
                            userid: id,
                            type: followed === false ? "FOLLOW" : "UNFOLLOW"
                        };
                        setIsLoading(true);
                        _ctx.next = 5;
                        return dispatch(slice/* effects.followStreamLikers */.Sz.followStreamLikers(data));
                    case 5:
                        follow = _ctx.sent;
                        error = follow.payload.error;
                        if (!error) {
                            setIsLoading(false);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleFollowUser() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleClickUserProfile = function(e) {
        e.preventDefault();
        StreamTabAnalytics/* default.common.Action.clickProfile */.ZP.common.Action.clickProfile(StreamTabAnalytics/* PAGE_SOURCE.LIKES */.nP.LIKES);
        ProfileAnalytics/* mainProfileEvents.onViewProfile */.j4.onViewProfile(ProfileAnalytics/* PAGE_SOURCE.streamLikeList */.nP.streamLikeList);
        // navigate to user profile
        router.push("/".concat(username, "?source=").concat(pageSourceIndex), undefined, {
            shallow: true
        });
    };
    var avatarUrl = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith("http")) ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(UserItemContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                mr: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        size: "small",
                        mr: "16px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: avatarUrl,
                            onError: function(e) {
                                return (0,general/* handleErrorAvatar */.Tk)(e, username);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/".concat(username, "?source=").concat(pageSourceIndex),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            onClick: handleClickUserProfile,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                                family: "bold",
                                                children: username
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Labels/* LabelVerifiedAccount */.uC, {
                                        deprecatedVerifiedStatus: user.is_verified
                                    })
                                ]
                            }),
                            fullname && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                color: color/* default.suvaGrey */.Z.suvaGrey,
                                children: fullname.substr(0, 100)
                            })
                        ]
                    })
                ]
            }),
            hasButton && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                type: buttonType,
                height: "32px",
                width: "100px",
                onClick: handleFollowUser,
                style: {
                    flexShrink: "0"
                },
                loading: isLoading,
                disabled: isLoading,
                radius: "4px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    family: "bold",
                    color: "inherit",
                    children: followingText
                })
            })
        ]
    });
}
/* harmony default export */ var ModalLike_UserItem = (UserItem);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalLike/index.tsx















function ModalLike(_param) {
    var likes = _param.likes, streamId = _param.streamId, visible = _param.visible, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "likes",
        "streamId",
        "visible"
    ]);
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var user = auth/* default.getUserAccess */.Z.getUserAccess();
    // @ts-ignore
    var userId = user.id;
    var userAccountId = 0;
    if (userId) {
        userAccountId = userId;
    }
    var ref3 = (0,es/* useSelector */.v9)(slice/* selectors */.wl), _streamLikers = ref3.streamLikers, streamLikersData = _streamLikers.data, isLoading = _streamLikers.isLoading;
    var isLastPage = ((ref = streamLikersData[streamId]) === null || ref === void 0 ? void 0 : ref.more) === false;
    var likersData = ((ref1 = streamLikersData[streamId]) === null || ref1 === void 0 ? void 0 : ref1.likers) || [];
    var handleGetLikers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var params, getLikers, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = {
                            postid: streamId,
                            page: 1
                        };
                        _ctx.next = 3;
                        return dispatch(slice/* effects.getStreamLikers */.Sz.getStreamLikers(params));
                    case 3:
                        getLikers = _ctx.sent;
                        error = getLikers.payload.error;
                        if (!error) {
                            setPage(page + 1);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleGetLikers() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleLoadMoreLikers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var params, getLikers, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        params = {
                            postid: streamId,
                            page: page
                        };
                        if (isLastPage) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 4;
                        return dispatch(slice/* effects.getStreamLikers */.Sz.getStreamLikers(params));
                    case 4:
                        getLikers = _ctx.sent;
                        error = getLikers.payload.error;
                        if (!error) {
                            setPage(page + 1);
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleLoadMoreLikers() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if (visible) {
            handleGetLikers();
            StreamTabAnalytics/* default.common.View.onLikesViewed */.ZP.common.View.onLikesViewed();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visible
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_Modal, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        type: "fullscreen",
        visible: visible,
        footer: null,
        destroyOnClose: true,
        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
            align: "center",
            size: "20px",
            height: "30px",
            family: "bold",
            children: [
                "Liked by ",
                likes,
                " people"
            ]
        }),
        transitionName: "",
        maskTransitionName: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserListContainer, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfiniteScroll/* default */.Z, {
                refineNext: handleLoadMoreLikers,
                hasMore: !isLastPage,
                loader: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                isLoading: isLoading || !streamLikersData[streamId],
                style: {
                    height: "100%",
                    maxHeight: 650,
                    overflow: "auto",
                    paddingRight: 10
                },
                children: likersData.map(function(u) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalLike_UserItem, {
                        user: u,
                        postid: streamId,
                        hasButton: u.id !== userAccountId
                    }, u.id);
                })
            })
        })
    }));
}
/* harmony default export */ var Modals_ModalLike = (ModalLike);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/Tooltip.js
var common_Tooltip = __webpack_require__(39211);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalLinkPost.tsx
/* eslint-disable react/jsx-wrap-multilines */ 










function ModalLinkPost(_param) {
    var postid = _param.postid, props = _object_without_properties(_param, [
        "postid"
    ]);
    var linkUrl = "".concat(SITE_URL, "/post/").concat(postid);
    var copyLink = function() {
        copyTextToClipboard(linkUrl);
    };
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, props), {
        title: /*#__PURE__*/ _jsx(Text, {
            size: "16px",
            height: "40px",
            weight: "bold",
            children: "Post Url"
        }),
        centered: true,
        width: 380,
        footer: null,
        children: [
            /*#__PURE__*/ _jsx(Text, {
                size: "12px",
                children: "Copy and paste this link to share this post "
            }),
            /*#__PURE__*/ _jsx(Input, {
                width: "100%",
                value: linkUrl,
                style: {
                    margin: "5px 0"
                },
                suffix: /*#__PURE__*/ _jsx(Tooltip, {
                    title: "Copy to clipboard",
                    children: /*#__PURE__*/ _jsx(IconWrapper, {
                        onClick: copyLink,
                        children: /*#__PURE__*/ _jsx(Iconmoon, {
                            className: "icon-toolbar_copy"
                        })
                    })
                })
            })
        ]
    }));
}
/* harmony default export */ var Modals_ModalLinkPost = ((/* unused pure expression or super */ null && (ModalLinkPost)));

// EXTERNAL MODULE: ./src/global/AlertErrorMessage/index.js + 1 modules
var AlertErrorMessage = __webpack_require__(25516);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalReport.tsx











function ModalReport(_param) {
    var onReport = _param.onReport, onCancel = _param.onCancel, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "onReport",
        "onCancel"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: constants/* defaultReportLabel */.u3
    }), 2), type = ref[0], setType = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: ""
    }), 2), message = ref1[0], setMessage = ref1[1];
    var handleSubmitReport = function() {
        if (message) {
            var data = {
                type: type,
                message: message
            };
            // send back form data to parent
            onReport(data);
        } else {
            (0,AlertErrorMessage/* default */.Z)("Report reason cannot be empty", "alert-red", false);
        }
    };
    var onChangeType = function(e) {
        setType(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* SModalReport */.wx, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        onCancel: onCancel
    }, props), {
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
            size: "16px",
            height: "40px",
            family: "bold",
            children: "Report Stream"
        }),
        centered: true,
        width: 280,
        footer: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                block: true,
                height: "40px",
                onClick: onCancel,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    children: "Cancel"
                })
            }, "cancel"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Button */.zx, {
                block: true,
                type: "primary",
                height: "40px",
                onClick: handleSubmitReport,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                    align: "center",
                    color: color/* default.light */.Z.light,
                    children: "Submit"
                })
            }, "confirm"), 
        ],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "12px",
                children: "Report type : "
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Select */.Ph, {
                value: type,
                onChange: onChangeType,
                children: constants/* reportOptions.map */.c$.map(function(param) {
                    var label = param.label, key = param.key;
                    return(// @ts-expect-error
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Option */.Wx, {
                        value: label,
                        children: label
                    }, key));
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                size: "12px",
                mt: "5px",
                children: "Why is this message inappropriate?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextArea */.Kx, {
                value: message,
                onChange: setMessage,
                rows: 8
            })
        ]
    }));
}
/* harmony default export */ var Modals_ModalReport = (ModalReport);

// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/lib/entities/tipping.js
var tipping = __webpack_require__(98585);
// EXTERNAL MODULE: ./src/constants/errorMessage.js
var errorMessage = __webpack_require__(61608);
// EXTERNAL MODULE: ./src/utils/source.ts
var source = __webpack_require__(9486);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalTipping.tsx
/* eslint-disable no-console */ 























/**
 * Modal Tipping
 * @example
 * const streamId = 123;
 * const username = "stockbit";
 * const avatar = "someuseravatar.png";
 * <ModalTipping streamId={streamId} username={username} avatar={avatar} />
 */ function ModalTipping(_param) {
    var streamId = _param.streamId, userId = _param.userId, username = _param.username, avatar = _param.avatar, _onCancel = _param.onCancel, onCancel = _onCancel === void 0 ? function() {} : _onCancel, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "streamId",
        "userId",
        "username",
        "avatar",
        "onCancel"
    ]);
    var pageSource = (0,source/* getAnalyticsPageSource */.u)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)(0), amount = ref[0], setAmount = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useForm/* default */.Z)({
        initialState: ""
    }), 2), message = ref1[0], setMessage = ref1[1];
    var ref2 = (0,react.useState)(null), clientKey = ref2[0], setClientKey = ref2[1];
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(api/* AVATAR_URL */.q$, "/").concat(avatar);
    var handleChangeAmount = function(val) {
        if (val.value !== "") {
            setAmount(parseFloat(val.value));
        } else {
            setAmount(0);
        }
    };
    var handleSetAmount = function(val) {
        setAmount(val);
        StreamTabAnalytics/* default.common.Action.clickTippingAmount */.ZP.common.Action.clickTippingAmount({
            streamId: streamId,
            userId: userId
        });
    };
    var handleSubmitTip = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var tipData, sendTip, _payload, error, _data, data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!amount) {
                            _ctx.next = 11;
                            break;
                        }
                        if (!(amount > constants/* MAX_TIPPING_AMOUNT */.gd)) {
                            _ctx.next = 5;
                            break;
                        }
                        {
                            (0,AlertErrorMessage/* default */.Z)(errorMessage/* default.TIPPING_MAX_AMOUNT_ERROR */.Z.TIPPING_MAX_AMOUNT_ERROR, errorMessage/* default.ALERT_RED */.Z.ALERT_RED);
                        }
                        _ctx.next = 11;
                        break;
                    case 5:
                        tipData = {
                            tippable: {
                                id: streamId,
                                type: "TYPE_STREAM"
                            },
                            amount: amount,
                            message: message
                        };
                        _ctx.next = 8;
                        return dispatch(tipping/* effects.sendTipping */.Sz.sendTipping(tipData));
                    case 8:
                        sendTip = _ctx.sent;
                        _payload = sendTip.payload, error = _payload.error, _data = _payload.data, data = _data === void 0 ? null : _data;
                        if (!error && data) {
                            if (pageSource) {
                                StreamTabAnalytics/* default.common.Action.clickSubmitTip */.ZP.common.Action.clickSubmitTip({
                                    pageSource: pageSource,
                                    amount: amount,
                                    message: message,
                                    postid: streamId,
                                    userId: userId,
                                    username: username
                                });
                            }
                            // const { action } = data;
                            setClientKey(data.client_key);
                            // eslint-disable-next-line no-undef
                            snap.pay(data.snap_token, {
                                onSuccess: function onSuccess() {
                                    ;
                                    // console.log(result);
                                    onCancel();
                                },
                                onPending: function onPending() {
                                    // console.log('snapPending');
                                    // console.log(result);
                                    onCancel();
                                },
                                onError: function onError() {
                                    ;
                                    // console.log(result);
                                    onCancel();
                                },
                                onClose: function onClose() {
                                    onCancel();
                                    ;
                                }
                            });
                        }
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmitTip() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: api/* GOPAY_URL_JAVASCRIPT */.uJ,
                "data-client-key": clientKey
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Modal */.u_, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
                onCancel: onCancel,
                centered: true,
                footer: null,
                width: 400,
                maskStyle: {
                    backgroundColor: "rgba(0,0,0,0.8)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TippingWrapper */.sD, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            align: "center",
                            weight: "bold",
                            size: "16px",
                            children: "Isi jumlah tip"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(common_Text/* default */.Z, {
                            align: "center",
                            size: "12px",
                            color: color/* default.midgray */.Z.midgray,
                            children: [
                                "untuk ",
                                username
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            justify: "center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                size: "large",
                                padding: "15px 0 0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "",
                                    src: avatarUrl
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            padding: "12px 0",
                            children: "Jumlah tip"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            justify: "space-between",
                            margin: "0 0 15px",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonTipping */.Is, {
                                    isSelected: amount === 5000,
                                    onClick: function() {
                                        return handleSetAmount(5000);
                                    },
                                    children: "Rp5,000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonTipping */.Is, {
                                    isSelected: amount === 10000,
                                    onClick: function() {
                                        return handleSetAmount(10000);
                                    },
                                    children: "Rp10,000"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonTipping */.Is, {
                                    isSelected: amount === 20000,
                                    onClick: function() {
                                        return handleSetAmount(20000);
                                    },
                                    children: "Rp20,000"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputAmountTipping */.bM, {
                            value: amount === 0 ? "" : amount,
                            thousandSeparator: true,
                            prefix: "Rp",
                            onValueChange: handleChangeAmount,
                            allowNegative: false,
                            name: "tipAmount",
                            placeholder: "Masukkan jumlah tip disini",
                            className: "ant-input"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                            padding: "18px 0 12px 0",
                            size: "12px",
                            children: "Pesan"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* TextareaTippingMessage */.N1, {
                            value: message,
                            onChange: function(e) {
                                setMessage(e);
                                StreamTabAnalytics/* default.common.Action.changeTippingMessage */.ZP.common.Action.changeTippingMessage();
                            },
                            rows: 4,
                            placeholder: "Isi pesan",
                            // @ts-expect-error
                            height: "62px"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ButtonSendTipping */.B9, {
                            block: true,
                            type: "primary",
                            margin: "20px 0 0",
                            height: "40px",
                            // @ts-expect-error
                            round: true,
                            onClick: handleSubmitTip,
                            disabled: amount === 0,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(common_Text/* default */.Z, {
                                align: "center",
                                color: color/* default.light */.Z.light,
                                family: "bold",
                                children: "Kirim dengan GO-PAY"
                            })
                        })
                    ]
                })
            }))
        ]
    });
}
/* harmony default export */ var Modals_ModalTipping = (ModalTipping);

;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/index.tsx









/***/ }),

/***/ 78690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_PollingContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/StreamWidget/TextContent/index.tsx
var TextContent = __webpack_require__(13683);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/StreamWidget/PollingContainer/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 3px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px 20px;\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 20px 23px;\n  background: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 60px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: ",
        ";\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 4px;\n  height: 40px;\n  position: absolute;\n  transition: all 0.5s ease;\n  width: ",
        ";\n\n  ",
        ";\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: none;\n      border-color: transparent;\n      border-radius: 3px;\n      box-shadow: none;\n      /* cursor: default; */\n      :hover,\n      :focus,\n      :active {\n        background: none;\n        border-color: transparent;\n      }\n    "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: flex-start;\n  transition: all 0.25s ease;\n  border-radius: 3px;\n  \n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



/**
 *
 *  Stream Content Polling Area
 *
 */ var PollingWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-0"
})(_templateObject());
var ContentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-1"
})(_templateObject1());
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-2"
})(_templateObject2(), color/* default.gainsboro */.Z.gainsboro);
var PollingHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-3"
})(_templateObject3(), color/* default.gainsboro */.Z.gainsboro);
var PollingContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-4"
})(_templateObject4(), color/* default.snow */.Z.snow);
var PollingValue = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-5"
})(_templateObject5());
var PollingBarWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9e97f319-6"
})(_templateObject6());
var PollingBar = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        width: props.width || "100%"
    };
}).withConfig({
    componentId: "sc-9e97f319-7"
})(_templateObject8(), function(param) {
    var width = param.width;
    return width;
}, function(param) {
    var fill = param.fill;
    return fill && (0,styled_components_browser_esm/* css */.iv)(_templateObject7(), color/* default.bubbles */.Z.bubbles);
});
var ButtonPolling = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    // @ts-ignore
    shouldForwardProp: function(prop) {
        return ![
            "fill"
        ].includes(prop);
    }
}).attrs(function(props) {
    return {
        fill: props.fill,
        margin: "0 0 12px",
        height: "40px",
        block: true,
        padding: 0
    };
}).withConfig({
    componentId: "sc-9e97f319-8"
})(_templateObject10(), function(param) {
    var fill = param.fill;
    return fill && (0,styled_components_browser_esm/* css */.iv)(_templateObject9());
});


;// CONCATENATED MODULE: ./src/global/StreamWidget/PollingContainer/PollingOption.tsx









function PollingOption(_param) {
    var _fill = _param.fill, fill = _fill === void 0 ? false : _fill, _isChoice = _param.isChoice, isChoice = _isChoice === void 0 ? false : _isChoice, _textPolling = _param.textPolling, textPolling = _textPolling === void 0 ? "" : _textPolling, _pollingValue = _param.pollingValue, pollingValue = _pollingValue === void 0 ? "" : _pollingValue, onClick = _param.onClick, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "fill",
        "isChoice",
        "textPolling",
        "pollingValue",
        "onClick"
    ]);
    var parsedText = textPolling;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        justify: "space-between",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingBarWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingBar, {
                        width: fill ? pollingValue : "100%",
                        fill: fill
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonPolling, {
                        fill: fill,
                        onClick: onClick,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    color: fill ? color/* default.black */.Z.black : color/* default.primary */.Z.primary,
                                    padding: "0 12px",
                                    weight: "normal",
                                    size: "14.5px",
                                    children: parsedText
                                }),
                                isChoice && /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* default */.Z, {
                                    className: "icon-custom_verified-circle",
                                    size: "16px",
                                    color: color/* default.primary */.Z.primary
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingValue, {
                children: fill && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    height: "40px",
                    align: "right",
                    children: pollingValue
                })
            })
        ]
    }));
}
/* harmony default export */ var PollingContainer_PollingOption = (PollingOption);

// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/YoutubePlayer.tsx
var YoutubePlayer = __webpack_require__(74132);
;// CONCATENATED MODULE: ./src/global/StreamWidget/PollingContainer/index.tsx













function PollingContainer(param) {
    var post = param.post, isSinglePost = param.isSinglePost, isTextDefaultExpand = param.isTextDefaultExpand, _highlightWord = param.highlightWord, highlightWord = _highlightWord === void 0 ? "" : _highlightWord;
    var dispatch = (0,es/* useDispatch */.I0)();
    // select data
    var ref = (0,es/* useSelector */.v9)(slice/* selectors */.wl), isLoading = ref.postVotePolling.isLoading;
    var content = post.content, contentOriginal = post.content_original, maskedHtml = post.mask_html;
    var polling = post.polling[0];
    var pollingId = polling.id, choiceKey = polling.my_vote, expired = polling.expired;
    var filled = choiceKey !== -1;
    // const filled = choiceKey !== '';
    var getOptionPercentage = function(voteCount) {
        var total = polling.total_voters;
        // eslint-disable-next-line no-mixed-operators
        var percentage = voteCount / total * 100;
        return "".concat(numeral_default()(percentage).format("0,0"), "%");
    };
    var handleVote = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(optionId) {
            var payload, votePolling, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        payload = {
                            pollingId: pollingId,
                            optionId: optionId,
                            postid: post.postid
                        };
                        if (!filled) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        _ctx.next = 5;
                        return dispatch(slice/* effects.postVotePolling */.Sz.postVotePolling(payload));
                    case 5:
                        votePolling = _ctx.sent;
                        error = votePolling.payload.error;
                        if (error) {
                            (0,AlertMessage/* default */.Z)({
                                content: error === null || error === void 0 ? void 0 : error.message,
                                messageType: "error",
                                alertType: "plain-default",
                                hasCloseIcon: false
                            });
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleVote(optionId) {
            return _ref.apply(this, arguments);
        };
    }();
    var autoplayYoutube = !isSinglePost;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentWrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingHeader, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                color: color/* default.nobel */.Z.nobel,
                                children: "POLL"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextContent/* default */.Z, {
                                family: "bold",
                                content: content,
                                maskedHtml: maskedHtml,
                                style: {
                                    marginBottom: "0px"
                                },
                                isDefaultExpand: isTextDefaultExpand,
                                size: "14.5px",
                                color: color/* default.nero */.Z.nero,
                                highlightWord: highlightWord
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(YoutubePlayer/* default */.Z, {
                        content: contentOriginal,
                        autoplay: autoplayYoutube
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PollingContent, {
                        children: [
                            polling.options.map(function(item) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PollingContainer_PollingOption, {
                                    textPolling: item.value,
                                    pollingValue: getOptionPercentage(item.count_voters),
                                    fill: filled,
                                    onClick: function() {
                                        return handleVote(item.id);
                                    },
                                    isChoice: choiceKey === item.id,
                                    isLoading: isLoading
                                }, item.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "13px",
                                color: color/* default.suvaGrey */.Z.suvaGrey,
                                children: [
                                    polling.total_voters,
                                    " votes \xb7 ",
                                    polling.message_expired
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var StreamWidget_PollingContainer = (PollingContainer);


/***/ }),

/***/ 55424:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11237);








var PDFPreview = next_dynamic__WEBPACK_IMPORTED_MODULE_5___default()(function() {
    return __webpack_require__.e(/* import() */ 39467).then(__webpack_require__.bind(__webpack_require__, 39467));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39467)
            ];
        }
    },
    ssr: false
});
function DocumentContainer(param) {
    var documents = param.documents, _maxHeight = param.maxHeight, maxHeight = _maxHeight === void 0 ? "480px" : _maxHeight, _dataCyName = param.dataCyName, dataCyName = _dataCyName === void 0 ? "" : _dataCyName;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(null), previewPdf = ref[0], setPreviewPdf = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var pdfFiles = documents.filter(function(doc) {
            return (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .decideFileType */ .GC)(doc) === "file-pdf";
        });
        if (pdfFiles.length > 0) {
            setPreviewPdf(pdfFiles[pdfFiles.length - 1]);
        }
    }, [
        documents
    ]);
    if (previewPdf) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            "data-cy": dataCyName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PDFPreview, {
                src: previewPdf,
                maxHeight: maxHeight
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            marginBottom: "16px"
        },
        "data-cy": dataCyName,
        children: documents.map(function(doc) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* .IconWrapper */ .a, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            className: "icon-compose_file"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        as: "a",
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary,
                        href: doc,
                        onClick: function(e) {
                            return e.stopPropagation();
                        },
                        children: (0,_utils__WEBPACK_IMPORTED_MODULE_7__/* .showFileName */ .yk)(doc)
                    })
                ]
            });
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (DocumentContainer);


/***/ }),

/***/ 5373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var global_Labels__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94493);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(579);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37213);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42227);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86123);
/* harmony import */ var features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(63576);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var global_AlertMessage__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6430);
/* harmony import */ var constants_successMessage__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(41208);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(29658);
/* harmony import */ var _Popover__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(77977);
/* harmony import */ var _StreamItemOption__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(98453);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(97986);
/* harmony import */ var _Modals__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(50700);
/* harmony import */ var _WarningBadge__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57543);
























function Header(param) {
    var post = param.post, _avatarSize = param.avatarSize, avatarSize = _avatarSize === void 0 ? "medium" : _avatarSize, _isLoggedIn = param.isLoggedIn, isLoggedIn = _isLoggedIn === void 0 ? false : _isLoggedIn, _withMenu = param.withMenu, withMenu = _withMenu === void 0 ? true : _withMenu, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, entryPoint = param.entryPoint;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(false), modalReport = ref[0], showModalReport = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(false), modalWarning = ref1[0], setModalWarning = ref1[1];
    var avatar = post.avatar, created = post.created_display, username = post.username, official = post.official, saved = post.saved, follow = post.follow, postid = post.postid, userid = post.userid, privilege = post.user_priv, updated = post.updated, polling = post.polling, isJunk = post.isJunk, isSpam = post.isSpam, is_violation = post.is_violation;
    var avatarUrl = (avatar === null || avatar === void 0 ? void 0 : avatar.startsWith("http")) ? avatar : "".concat(constants_api__WEBPACK_IMPORTED_MODULE_9__/* .AVATAR_URL */ .q$, "/").concat(avatar);
    var isFollowed = follow === 1;
    // eslint-disable-next-line use-isnan
    var hasEdited = updated !== "0000-00-00 00:00:00";
    var isPolling = polling.length > 0;
    var getPageSourceIndex = function() {
        if (!(0,constants_app__WEBPACK_IMPORTED_MODULE_11__/* .isClient */ .C5)()) {
            return "";
        }
        var href = window.location.href;
        if (href.includes("/symbol/")) {
            return features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__/* .PAGE_SOURCE_INDEX.findIndex */ .en.findIndex(function(sourceIndex) {
                return sourceIndex === "Company Page";
            });
        }
        if (href.includes("/stream")) {
            return features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__/* .PAGE_SOURCE_INDEX.findIndex */ .en.findIndex(function(sourceIndex) {
                return sourceIndex === "Stream Post";
            });
        }
        return "";
    };
    var viewProfileAnalytics = function() {
        var href = window.location.href;
        var pageSource;
        if (href.includes("/symbol/")) {
            pageSource = features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__/* .PAGE_SOURCE.companyPage */ .nP.companyPage;
        } else if (href.includes("/stream")) {
            pageSource = features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__/* .PAGE_SOURCE.streamPost */ .nP.streamPost;
        }
        if (pageSource) {
            features_user_analytics_ProfileAnalytics__WEBPACK_IMPORTED_MODULE_12__/* .mainProfileEvents.onViewProfile */ .j4.onViewProfile(pageSource);
        }
    };
    var handleReportPost = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(val) {
            var data, report, ref, error;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)({
                            postid: postid
                        }, val);
                        _ctx.next = 3;
                        return dispatch(effects.postReportStream(data));
                    case 3:
                        report = _ctx.sent;
                        ;
                        error = ((ref = report === null || report === void 0 ? void 0 : report.payload) !== null && ref !== void 0 ? ref : {}).error;
                        if (!error) {
                            showModalReport(false);
                            setModalWarning(false);
                            (0,global_AlertMessage__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                                content: constants_successMessage__WEBPACK_IMPORTED_MODULE_15__/* ["default"].REPORT_DELIVERED */ .Z.REPORT_DELIVERED,
                                alertType: "snackbar",
                                messageType: "success",
                                hasCloseIcon: false
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReportPost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        width: "100%",
        className: "header",
        children: [
            isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Popover__WEBPACK_IMPORTED_MODULE_16__/* .PopoverUser */ .q, {
                username: username,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                        href: "/".concat(username, "?source=").concat(getPageSourceIndex()),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            href: "dummy",
                            onClick: viewProfileAnalytics,
                            style: {
                                color: "unset"
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                size: avatarSize,
                                padding: "0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    alt: "imageProfile",
                                    src: avatarUrl,
                                    onError: function(e) {
                                        return (0,utils_general__WEBPACK_IMPORTED_MODULE_10__/* .handleErrorAvatar */ .Tk)(e, username);
                                    },
                                    style: {
                                        cursor: "pointer"
                                    }
                                })
                            })
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                href: "/".concat(username, "?source=").concat(getPageSourceIndex()),
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                    href: "dummy",
                    onClick: viewProfileAnalytics,
                    style: {
                        color: "unset"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        size: avatarSize,
                        padding: "0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            alt: "imageProfile",
                            src: avatarUrl,
                            onError: function(e) {
                                return (0,utils_general__WEBPACK_IMPORTED_MODULE_10__/* .handleErrorAvatar */ .Tk)(e, username);
                            },
                            style: {
                                cursor: "pointer"
                            }
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .HeaderContent */ .oB, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                align: "center",
                                children: [
                                    isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Popover__WEBPACK_IMPORTED_MODULE_16__/* .PopoverUser */ .q, {
                                        username: username,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            className: "popover-trigger-".concat(username),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                href: "/".concat(username, "?source=").concat(getPageSourceIndex()),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .TextHeader */ .Y, {
                                                    onClick: viewProfileAnalytics,
                                                    size: "16px",
                                                    family: "bold",
                                                    children: username
                                                })
                                            })
                                        })
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                        href: "/".concat(username, "?source=").concat(getPageSourceIndex()),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .TextHeader */ .Y, {
                                            onClick: viewProfileAnalytics,
                                            size: "16px",
                                            family: "bold",
                                            children: username
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                        align: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Labels__WEBPACK_IMPORTED_MODULE_5__/* .LabelVerifiedAccount */ .uC, {
                                                deprecatedVerifiedStatus: official > 0,
                                                verifiedStatus: post === null || post === void 0 ? void 0 : post.verified_status
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Labels__WEBPACK_IMPORTED_MODULE_5__/* .LabelAdmin */ .SH, {
                                                privilege: privilege
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_6___default()), {
                                href: "/post/".concat(postid),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                                    style: {
                                        color: "unset"
                                    },
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .TextHeader */ .Y, {
                                        size: "12px",
                                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].midgray */ .Z.midgray,
                                        children: [
                                            created,
                                            hasEdited ? " Edited on ".concat(moment__WEBPACK_IMPORTED_MODULE_7___default()(updated).format("D MMM YY, HH:mm")) : null
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .BadgeJunkWrapper */ .Jm, {
                        style: {
                            position: "absolute",
                            right: 25
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .BadgeJunk */ .Iw, {
                                type: "junk",
                                visible: isJunk,
                                children: "Potential Junk"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_18__/* .BadgeJunk */ .Iw, {
                                type: "spam",
                                visible: isSpam,
                                children: "Potential Spam"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_WarningBadge__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                visible: !withMenu && is_violation,
                                modalReport: modalReport,
                                showModalReport: showModalReport,
                                modalWarning: modalWarning,
                                setModalWarning: setModalWarning
                            })
                        ]
                    }),
                    withMenu && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_StreamItemOption__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                        userId: userid,
                        postId: postid,
                        post: post,
                        saved: saved,
                        followed: isFollowed,
                        showFollowNotification: false,
                        isPolling: isPolling,
                        type: "post",
                        entryPoint: entryPoint,
                        symbol: symbol,
                        isViolation: is_violation
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                        condition: !withMenu && is_violation,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Modals__WEBPACK_IMPORTED_MODULE_19__/* .ModalReport */ .aA, {
                            visible: modalReport,
                            destroyOnClose: true,
                            onReport: handleReportPost,
                            onCancel: function() {
                                return showModalReport(false);
                            }
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 38294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57788);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var global_Labels__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(94493);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(579);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37213);
/* harmony import */ var global_ImageSlider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9649);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(42227);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86123);
/* harmony import */ var features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(13946);
/* harmony import */ var _TextContent__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(13683);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97986);
/* harmony import */ var _YoutubePlayer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74132);
/* harmony import */ var _DocumentContainer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(55424);

















function RepostBox(param) {
    var post = param.post;
    var ref;
    var content = post.content_original, title = post.title, newsSource = post.newsfeed_source, newsLabel = post.newsfeed_label, newsImg = post.newsfeed_img, avatar = post.avatar, username = post.username, // images,
    postid = post.postid, official = post.official, isUnavailable = post.is_unavailable, maskHtml = post.mask_html, imagesData = post.images_data, imageFrameType = post.image_frame_type, attachment = post.attachment;
    if (isUnavailable) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: "/post/".concat(postid),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                target: "_blank",
                rel: "noopener noreferrer",
                "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_UNAVAILABLE */ .ks,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .RepostBoxContainer */ .Iy, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray,
                        children: "This post is unavailable."
                    })
                })
            })
        });
    }
    var avatarUrl = avatar.startsWith("http") ? avatar : "".concat(constants_api__WEBPACK_IMPORTED_MODULE_8__/* .AVATAR_URL */ .q$, "/").concat(avatar || "");
    var isHaveImage = Boolean((imagesData === null || imagesData === void 0 ? void 0 : imagesData.length) > 0 && ((ref = imagesData[0]) === null || ref === void 0 ? void 0 : ref.image));
    var handleClickRepostBox = function() {
        var path = !constants_app__WEBPACK_IMPORTED_MODULE_11__/* .PROJECT_FOLDER */ .sP || constants_app__WEBPACK_IMPORTED_MODULE_11__/* .PROJECT_FOLDER */ .sP === "/" ? "/" : "/".concat(constants_app__WEBPACK_IMPORTED_MODULE_11__/* .PROJECT_FOLDER */ .sP, "/");
        window.open("".concat(window.location.origin).concat(path, "post/").concat(post.postid), "_blank");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .RepostBoxContainer */ .Iy, {
        onClick: handleClickRepostBox,
        "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX */ .PZ,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Avatar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        size: "x-small",
                        // @ts-expect-error
                        mr: "12px",
                        "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_AVATAR */ .O4,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            src: avatarUrl,
                            alt: username,
                            onError: function(e) {
                                return (0,utils_general__WEBPACK_IMPORTED_MODULE_10__/* .handleErrorAvatar */ .Tk)(e, username);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        family: "bold",
                        size: "16px",
                        "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_USERNAME */ .Df,
                        children: username
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Labels__WEBPACK_IMPORTED_MODULE_6__/* .LabelVerifiedAccount */ .uC, {
                        deprecatedVerifiedStatus: official > 0,
                        verifiedStatus: post === null || post === void 0 ? void 0 : post.verified_status
                    })
                ]
            }),
            isHaveImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_13__/* .RepostImageContainer */ .YA, {
                "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_IMAGE */ .tz,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            clear: "both"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_ImageSlider__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                        images: imagesData,
                        frameType: imageFrameType,
                        isRepost: true
                    })
                ]
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary,
                // @ts-expect-error
                mb: "8px",
                "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_TITLE */ .BC,
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                height: "22.475px",
                "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_CONTENT */ .zP,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_TextContent__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    content: content,
                    maskedHtml: maskHtml,
                    isDefaultExpand: false,
                    isRepost: true,
                    style: {
                        marginBottom: 0
                    }
                })
            }),
            !isHaveImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_YoutubePlayer__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                content: content,
                dataCyName: features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_YOUTUBE_PLAYER */ .ov
            }),
            newsSource && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                // @ts-expect-error
                mt: "10px",
                "data-cy": features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_NEWS_SOURCE */ .dL,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        alt: newsLabel,
                        src: newsImg,
                        style: {
                            width: "16px",
                            marginRight: "8px"
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        size: "12px",
                        children: newsLabel
                    })
                ]
            }),
            (attachment === null || attachment === void 0 ? void 0 : attachment.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DocumentContainer__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                documents: attachment,
                dataCyName: features_chat_MainContent_ChatPreview_tests_constant__WEBPACK_IMPORTED_MODULE_16__/* .DATA_CY_NAME_CHAT_PAGE_MAIN_CONTENT_CHAT_PREVIEW_REPOST_BOX_DOCUMENT_ATTACHMENT */ .BO
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (RepostBox);


/***/ }),

/***/ 98453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Post_StreamItemOption; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/IconMoreOptions.js
var IconMoreOptions = __webpack_require__(48253);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Iconmoon.js
var Iconmoon = __webpack_require__(15807);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Popover.js
var Popover = __webpack_require__(70187);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/index.jsx + 7 modules
var Modals = __webpack_require__(31359);
// EXTERNAL MODULE: ./src/utils/userRole.js
var userRole = __webpack_require__(58080);
// EXTERNAL MODULE: ./src/utils/auth.js + 1 modules
var auth = __webpack_require__(19225);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
// EXTERNAL MODULE: ./src/global/AlertMessage/index.tsx
var AlertMessage = __webpack_require__(6430);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/constants/successMessage.js
var successMessage = __webpack_require__(41208);
;// CONCATENATED MODULE: ./src/assets/customIcon/stream-icon/IconBell.tsx


function IconBell() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#969696",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.2,
            d: "M12.25 10.5H1.75a11.01 11.01 0 0 0 1.167-4.94v-.31A4.08 4.08 0 0 1 7 1.167a4.08 4.08 0 0 1 4.083 4.083v.31c0 1.714.403 3.406 1.167 4.94ZM5.938 12.145c.181.402.59.688 1.062.688.473 0 .88-.286 1.062-.688"
        })
    });
};

;// CONCATENATED MODULE: ./src/assets/customIcon/stream-icon/IconBellActive.tsx


function IconBellActive() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            stroke: "#00ab6b",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.2,
            d: "M12.25 10.5H1.75a11.01 11.01 0 0 0 1.167-4.94v-.31A4.08 4.08 0 0 1 7 1.167a4.08 4.08 0 0 1 4.083 4.083v.31c0 1.714.403 3.406 1.167 4.94ZM5.938 12.145c.181.402.59.688 1.062.688.473 0 .88-.286 1.062-.688"
        })
    });
};

// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/index.tsx + 9 modules
var StreamWidget_Modals = __webpack_require__(50700);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/OptionItem.tsx
/* eslint-disable react/forbid-prop-types */ 







function OptionItem(_param) {
    var children = _param.children, _isActive = _param.isActive, isActive = _isActive === void 0 ? false : _isActive, iconName = _param.iconName, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "isActive",
        "iconName"
    ]);
    var iconFile = isActive ? "icon/post-".concat(iconName, "-active.svg") : "icon/post-".concat(iconName, ".svg");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* OptionItemContainer */.OF, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherProps), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                width: "16",
                height: "15",
                src: iconFile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                ml: "12px",
                children: children
            })
        ]
    }));
}
/* harmony default export */ var Post_OptionItem = (OptionItem);

// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/@deprecated-ui/utils/hexOpacity.js
var hexOpacity = __webpack_require__(84607);
// EXTERNAL MODULE: ./src/utils/stream.js
var stream = __webpack_require__(14601);
// EXTERNAL MODULE: ./src/lib/entities/stream.ts
var entities_stream = __webpack_require__(25641);
// EXTERNAL MODULE: ./src/global/StreamCompose/index.tsx + 25 modules
var StreamCompose = __webpack_require__(76897);
// EXTERNAL MODULE: ./src/global/StreamCompose/constants.ts
var constants = __webpack_require__(79030);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/styled.ts
var Modals_styled = __webpack_require__(89784);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalEditPost.tsx
















function ModalEditPost(_param) {
    var post = _param.post, onCancel = _param.onCancel, props = (0,_object_without_properties/* default */.Z)(_param, [
        "post",
        "onCancel"
    ]);
    var selectedPost = (0,react.useMemo)(function() {
        return (0,stream/* parseStreamPostContent */.vO)(post);
    }, [
        post
    ]);
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(entities_stream/* selectors */.wl), isLoading = ref.updatePostStream.isLoading;
    var handleEditPost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var data, update, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), {
                            postid: post.postid
                        });
                        _ctx.next = 3;
                        return dispatch(entities_stream/* effects.updatePostStream */.Sz.updatePostStream((0,_object_spread/* default */.Z)({}, data)));
                    case 3:
                        update = _ctx.sent;
                        error = update.payload.error;
                        if (!error) {
                            onCancel();
                        }
                        return _ctx.abrupt("return", error);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleEditPost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_styled/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        onCancel: onCancel,
        centered: true,
        maskStyle: {
            backgroundColor: "".concat(color/* default.black */.Z.black).concat((0,hexOpacity/* default */.Z)(80))
        },
        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
            size: "18px",
            height: "44px",
            family: "bold",
            align: "center",
            children: "Edit on Idea"
        }),
        footer: null,
        width: 660,
        bodyStyle: {
            padding: "0px"
        },
        transitionName: "",
        maskTransitionName: "",
        destroyOnClose: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamCompose/* default */.Z, {
            mode: constants/* COMPOSE_MODE.EDIT */.ZX.EDIT,
            initialValues: selectedPost,
            isLoading: isLoading,
            onSubmit: handleEditPost,
            onCancel: onCancel
        })
    }));
}
/* harmony default export */ var Modals_ModalEditPost = (ModalEditPost);

// EXTERNAL MODULE: ./src/features/stream/analytics/CommentAnalytics.ts
var CommentAnalytics = __webpack_require__(90506);
// EXTERNAL MODULE: ./src/global/StreamCompose/CommentSetting/CommentSettingPopover.tsx + 1 modules
var CommentSettingPopover = __webpack_require__(23892);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/PopoverChangeCommenter.tsx






function PopoverChangeCommenter(param) {
    var visible = param.visible, hasMention = param.hasMention, defaultCommenterType = param.defaultCommenterType, popoverId = param.popoverId, onChange = param.onChange, onCancel = param.onCancel;
    var defaultCommenter = constants/* COMMENT_SETTING_LIST.find */.l2.find(function(comment) {
        return comment.type === defaultCommenterType;
    });
    var ref = (0,react.useState)(defaultCommenter), commenter = ref[0], setCommenter = ref[1];
    var onChangeCommenter = function(data) {
        setCommenter(data);
        onChange(data.type, data.label);
        CommentAnalytics/* default.Action.ChangeComment */.Z.Action.ChangeComment();
    };
    var commentTypeWithMention = hasMention || defaultCommenterType === "COMMENTER_TYPE_MENTION";
    var commentTypeList = constants/* COMMENT_SETTING_LIST */.l2;
    (0,react.useEffect)(function() {
        var defaultComment = constants/* COMMENT_SETTING_LIST.find */.l2.find(function(comment) {
            return comment.type === defaultCommenterType;
        });
        setCommenter(defaultComment);
    }, [
        defaultCommenterType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
        trigger: "contextMenu",
        placement: "bottomRight",
        overlayStyle: {
            minWidth: "145px"
        },
        content: function() {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentSettingPopover/* default */.Z, {
                commentSettingList: commentTypeList,
                commenter: commenter,
                onChangeCommenter: onChangeCommenter
            });
        },
        visible: visible,
        onVisibleChange: onCancel,
        getPopupContainer: function() {
            return document.getElementById(popoverId);
        },
        zIndex: 20,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                width: "1px",
                position: "absolute",
                right: 0,
                top: 10
            }
        })
    });
}
/* harmony default export */ var Post_PopoverChangeCommenter = (PopoverChangeCommenter);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/__tests__/constants.ts
var _tests_constants = __webpack_require__(18278);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/WarningBadge.tsx + 1 modules
var WarningBadge = __webpack_require__(57543);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/StreamItemOption.tsx































function StreamItemOption(param) {
    var post = param.post, _userId = param.userId, userId = _userId === void 0 ? 0 : _userId, _postId = param.postId, postId = _postId === void 0 ? 0 : _postId, _saved = param.saved, saved = _saved === void 0 ? false : _saved, _followed = param.followed, followed = _followed === void 0 ? false : _followed, _showFollowNotification = param.showFollowNotification, showFollowNotification = _showFollowNotification === void 0 ? false : _showFollowNotification, _isPolling = param.isPolling, isPolling = _isPolling === void 0 ? false : _isPolling, _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, type = param.type, entryPoint = param.entryPoint, _showDeleteAsAuthor = param.showDeleteAsAuthor, showDeleteAsAuthor = _showDeleteAsAuthor === void 0 ? false : _showDeleteAsAuthor, handleCloseConvo = param.handleCloseConvo, _isViolation = param.isViolation, isViolation = _isViolation === void 0 ? false : _isViolation;
    var ref;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref1 = (0,react.useState)(false), modalDelete = ref1[0], showModalDelete = ref1[1];
    var ref2 = (0,react.useState)(false), modalDeleteMultiple = ref2[0], showModalDeleteMultiple = ref2[1];
    var ref3 = (0,react.useState)(false), modalDeleteAuthor = ref3[0], showModalDeleteAuthor = ref3[1];
    var ref4 = (0,react.useState)(false), modalReport = ref4[0], showModalReport = ref4[1];
    var ref5 = (0,react.useState)(false), modalEdit = ref5[0], showModalEdit = ref5[1];
    var ref6 = (0,react.useState)(false), modalBlock = ref6[0], showModalBlock = ref6[1];
    var ref7 = (0,react.useState)(false), modalSuspend = ref7[0], showModalSuspend = ref7[1];
    var ref8 = (0,react.useState)(false), menuPopover = ref8[0], showMenuPopover = ref8[1];
    var ref9 = (0,react.useState)(false), popoverCommenter = ref9[0], showPopoverCommenter = ref9[1];
    var ref10 = (0,react.useState)(false), modalWarning = ref10[0], setModalWarning = ref10[1];
    var isAuthor = post.is_author > 0;
    // @ts-ignore
    var privilege = (ref = auth/* default.getUserAccess */.Z.getUserAccess()) === null || ref === void 0 ? void 0 : ref.privilege;
    var isMyRoleAdmin = (0,userRole/* getUserRole */.Rg)(privilege) === userRole/* UserRoleName.ADMIN */.xj.ADMIN;
    var isAdminPost = (0,userRole/* getUserRole */.Rg)(post.user_priv) === userRole/* UserRoleName.ADMIN */.xj.ADMIN;
    var isShowMuted = isMyRoleAdmin && !isAuthor && !isAdminPost;
    var isShowEdit = isAuthor && !isPolling;
    var isPinned = post.ispinned;
    var isShowDeletePostAdmin = isMyRoleAdmin ? !isAdminPost : false;
    var isShowDeleteMultiple = isMyRoleAdmin ? (!isAdminPost || isAuthor) && entryPoint !== "conversation" : false;
    var isShowUntag = isMyRoleAdmin ? entryPoint !== "conversation" && (0,userRole/* isAllowedToManageTop */._W)(privilege) : false;
    var isShowPinUnpin = isAuthor && entryPoint !== "stream" && entryPoint !== "conversation";
    // TODO: Handle follow (DONE), handle save post (DONE), handle pin (if necessary)
    var handleToggleFollow = function() {
        var action = followed ? slice/* effects.unfollowPost */.Sz.unfollowPost : slice/* effects.followPost */.Sz.followPost;
        // @ts-ignore
        dispatch(action(postId));
    };
    var handleToggleSave = function() {
        var action = saved ? slice/* effects.unsavePost */.Sz.unsavePost : slice/* effects.savePost */.Sz.savePost;
        // @ts-ignore
        dispatch(action(postId));
    };
    var handleTogglePin = function() {
        var action = post.ispinned ? slice/* effects.unpinPost */.Sz.unpinPost : slice/* effects.pinPost */.Sz.pinPost;
        var data = {
            postid: postId
        };
        // @ts-ignore
        dispatch(action(data));
    };
    var handleReportPost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var data, report, ref, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_object_spread/* default */.Z)({
                            postid: postId
                        }, val);
                        _ctx.next = 3;
                        return dispatch(slice/* effects.postReportStream */.Sz.postReportStream(data));
                    case 3:
                        report = _ctx.sent;
                        ;
                        error = ((ref = report === null || report === void 0 ? void 0 : report.payload) !== null && ref !== void 0 ? ref : {}).error;
                        if (!error) {
                            showModalReport(false);
                            setModalWarning(false);
                            (0,AlertMessage/* default */.Z)({
                                content: successMessage/* default.REPORT_DELIVERED */.Z.REPORT_DELIVERED,
                                alertType: "snackbar",
                                messageType: "success",
                                hasCloseIcon: false
                            });
                        }
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleReportPost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeletePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var data, deletePost, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), {
                            sendEmail: val.sendEmail,
                            postid: postId,
                            isAuthor: isAuthor && isMyRoleAdmin ? false : isAuthor,
                            type: type
                        });
                        _ctx.next = 3;
                        return dispatch(slice/* effects.deleteStreamPost */.Sz.deleteStreamPost(data));
                    case 3:
                        deletePost = _ctx.sent;
                        error = deletePost.payload.error;
                        if (!error) {
                            showModalDelete(false);
                            showModalDeleteAuthor(false);
                            if (handleCloseConvo) {
                                handleCloseConvo();
                            }
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeletePost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDeleteMultiplePost = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(val) {
            var data, deletePost, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        data = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, val), {
                            sendEmail: val.sendEmail,
                            userid: userId
                        });
                        _ctx.next = 3;
                        return dispatch(slice/* effects.deleteMultipleStreamPost */.Sz.deleteMultipleStreamPost(data));
                    case 3:
                        deletePost = _ctx.sent;
                        error = deletePost.payload.error;
                        if (!error) {
                            showModalDeleteMultiple(false);
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleDeleteMultiplePost(val) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUntagPost = function() {
        // @ts-ignore
        dispatch(slice/* effects.untagPost */.Sz.untagPost(postId));
    };
    var handleCopyLink = function() {
        var path = !app/* PROJECT_FOLDER */.sP || app/* PROJECT_FOLDER */.sP === "/" ? "/" : "/".concat(app/* PROJECT_FOLDER */.sP, "/");
        var copiedLink = "".concat(window.location.origin).concat(path, "post/").concat(post.postid);
        (0,general/* copyTextToClipboard */.TE)(copiedLink, function() {
            return (0,AlertMessage/* default */.Z)({
                content: "Link copied",
                alertType: "snackbar",
                messageType: "success",
                hasCloseIcon: true
            });
        });
        showMenuPopover(false);
    };
    var handleChangeCommenterType = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(commenterType, label) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return dispatch(slice/* effects.changeCommenter */.Sz.changeCommenter({
                            type: commenterType,
                            postid: postId,
                            label: label
                        }));
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangeCommenterType(commenterType, label) {
            return _ref.apply(this, arguments);
        };
    }();
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    if (!isLoggedIn) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
            align: "center",
            className: _tests_constants/* DATA_CY_POST_STREAM_ITEM_OPTION */.lV,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/register",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoreOptions/* default */.Z, {})
                })
            })
        });
    }
    var showCommenterPopover = function() {
        showPopoverCommenter(true);
        showMenuPopover(false);
    };
    var hasMention = Array.isArray(post.mask_html) && post.mask_html.some(function(mask) {
        return mask.text.indexOf("@") > -1;
    });
    var hasCommenter = isAuthor && (post.parent_postid === 0 || post.postid === post.parent_postid);
    var containerId = "stream-option-".concat(entryPoint, "-").concat(post.postid);
    var popoverId = "".concat(containerId, "-popover");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: containerId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: popoverId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                style: {
                    position: "relative"
                },
                className: _tests_constants/* DATA_CY_POST_STREAM_ITEM_OPTION */.lV,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showFollowNotification,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            // @ts-expect-error
                            mr: "8px",
                            style: {
                                cursor: "pointer"
                            },
                            onClick: handleToggleFollow,
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconmoon/* IconWrapper */.a, {
                                    size: "14px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* IconStyle */.ze, {
                                        children: followed ? /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBellActive, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(IconBell, {})
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* NotifText */.gp, {
                                    children: [
                                        "Turn ",
                                        followed ? "Off" : "On",
                                        " Notification"
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* BadgeJunkWrapper */.Jm, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WarningBadge/* default */.Z, {
                            visible: isViolation,
                            modalReport: modalReport,
                            showModalReport: showModalReport,
                            modalWarning: modalWarning,
                            setModalWarning: setModalWarning
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                        trigger: [
                            "contextMenu",
                            "click"
                        ],
                        placement: "bottomRight",
                        getPopupContainer: function() {
                            return document.getElementById(containerId);
                        },
                        overlayStyle: {
                            minWidth: "145px",
                            paddingTop: 0
                        },
                        visible: menuPopover,
                        onVisibleChange: function(visible) {
                            return showMenuPopover(visible);
                        },
                        zIndex: entryPoint !== "conversation" ? 20 : undefined,
                        autoAdjustOverflow: true,
                        content: function() {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* StreamOptionContainer */.JN, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                        iconName: "save",
                                        isActive: saved,
                                        onClick: handleToggleSave,
                                        "data-cy": "stream-item-option-save",
                                        children: saved ? "Saved" : "Save"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !showFollowNotification,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_OptionItem, {
                                            iconName: "follow",
                                            isActive: followed,
                                            onClick: handleToggleFollow,
                                            "data-cy": "stream-item-option-follow",
                                            children: [
                                                followed ? "Unfollow" : "Follow",
                                                " this Post"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowPinUnpin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_OptionItem, {
                                            iconName: "pin",
                                            isActive: isPinned,
                                            onClick: handleTogglePin,
                                            "data-cy": "stream-item-option-pin",
                                            children: [
                                                isPinned ? "Unpin" : "Pin",
                                                " this Post"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowEdit || isAuthor || isMyRoleAdmin && !isAdminPost,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StreamOptionDivider */.to, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowEdit,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "edit",
                                            onClick: function() {
                                                return showModalEdit(true);
                                            },
                                            "data-cy": "stream-item-option-edit",
                                            children: "Edit post"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: hasCommenter,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "comment",
                                            onClick: showCommenterPopover,
                                            "data-cy": "stream-item-option-who-can-comment",
                                            children: "Change Who Can Comment"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isAuthor,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_OptionItem, {
                                            iconName: "delete",
                                            onClick: function() {
                                                return showModalDeleteAuthor(true);
                                            },
                                            "data-cy": "stream-item-option-delete-author",
                                            children: [
                                                "Delete ",
                                                type
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowDeletePostAdmin,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_OptionItem, {
                                            iconName: "delete",
                                            onClick: function() {
                                                return showModalDelete(true);
                                            },
                                            "data-cy": "stream-item-option-delete-admin",
                                            children: [
                                                "Delete ",
                                                type
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowDeleteMultiple,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "delete-multiple",
                                            onClick: function() {
                                                return showModalDeleteMultiple(true);
                                            },
                                            "data-cy": "stream-item-option-delete-multiple",
                                            children: "Delete Multiple"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* StreamOptionDivider */.to, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowUntag,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "untag",
                                            onClick: handleUntagPost,
                                            "data-cy": "stream-item-option-untag",
                                            children: "Untag Post Topic"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: isShowMuted && entryPoint !== "conversation",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "mute",
                                            onClick: function() {
                                                return showModalSuspend(true);
                                            },
                                            "data-cy": "stream-item-option-mute",
                                            children: "Mute user"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                        condition: !isAuthor && !isAdminPost,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                            iconName: "block",
                                            onClick: function() {
                                                return showModalBlock(true);
                                            },
                                            "data-cy": "stream-item-option-block",
                                            children: "Block user"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                        iconName: "report",
                                        onClick: function() {
                                            return showModalReport(true);
                                        },
                                        "data-cy": "stream-item-option-report",
                                        children: "Report Abuse"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_OptionItem, {
                                        iconName: "link",
                                        onClick: handleCopyLink,
                                        "data-cy": "stream-item-option-copy",
                                        children: "Copy Link"
                                    })
                                ]
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconMoreOptions/* default */.Z, {
                            "data-cy": symbol ? _tests_constants/* DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY */.Hc : _tests_constants/* DATA_CY_STREAM_ITEM_OPTION_BUTTON */.bP,
                            onClick: function() {
                                return showMenuPopover(!menuPopover);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_PopoverChangeCommenter, {
                visible: popoverCommenter,
                hasMention: hasMention,
                defaultCommenterType: post.commenter_type,
                popoverId: popoverId,
                onChange: handleChangeCommenterType,
                onCancel: function(visible) {
                    return showPopoverCommenter(visible);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Modals/* ModalDeleteAuthor */.c5, {
                visible: modalDeleteAuthor,
                handleDelete: handleDeletePost,
                onCancel: function() {
                    return showModalDeleteAuthor(false);
                },
                type: "post"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Modals/* ModalDeleteAdmin */.tN, {
                visible: modalDelete,
                onDelete: handleDeletePost,
                onCancel: function() {
                    return showModalDelete(false);
                },
                isAdmin: isMyRoleAdmin,
                type: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Modals/* ModalDeleteAdmin */.tN, {
                multiple: true,
                visible: modalDeleteMultiple,
                onDelete: handleDeleteMultiplePost,
                onCancel: function() {
                    return showModalDeleteMultiple(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StreamWidget_Modals/* ModalReport */.aA, {
                visible: modalReport,
                destroyOnClose: true,
                onReport: handleReportPost,
                onCancel: function() {
                    return showModalReport(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_ModalEditPost, {
                visible: modalEdit,
                post: post,
                onCancel: function() {
                    return showModalEdit(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalBlockUser */.y2, {
                visible: modalBlock,
                userId: userId,
                username: post.username,
                onCancel: function() {
                    return showModalBlock(false);
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals/* ModalSuspendUser */.qb, {
                visible: modalSuspend,
                username: post.username,
                userId: userId,
                postId: postId,
                onCancel: function() {
                    return showModalSuspend(false);
                },
                onSubmit: function() {
                    return setModalWarning(false);
                }
            })
        ]
    });
}
/* harmony default export */ var Post_StreamItemOption = (StreamItemOption);


/***/ }),

/***/ 41447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Post_TitleContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 3 modules
var credentials = __webpack_require__(64435);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./src/global/StreamWidget/Modals/styled.ts
var styled = __webpack_require__(89784);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Modals/ModalAnnouncement.tsx













var Loading = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        style: {
            minHeight: "310px",
            width: "100%"
        },
        justify: "center",
        align: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AnnouncementLoading */.KP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/icon/announcement-loading.svg"
            })
        })
    });
};
function ModalAnnouncement(param) {
    var url = param.url, _visible = param.visible, visible = _visible === void 0 ? false : _visible, destroyOnClose = param.destroyOnClose, onCancel = param.onCancel;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var postId = (0,general/* getLastSlashURL */.C9)(url);
    var dispatch = (0,es/* useDispatch */.I0)();
    var announcementReports = (0,es/* useSelector */.v9)(slice/* selectors */.wl).announcementReports;
    var isLoading = announcementReports.isLoading;
    (0,react.useEffect)(function() {
        if (visible && postId) {
            // @ts-ignore
            dispatch(slice/* effects.getAnnouncementReports */.Sz.getAnnouncementReports(postId));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        postId,
        visible
    ]);
    var currentPost = announcementReports[postId] || [];
    var postedDate = ((ref = currentPost[0]) === null || ref === void 0 ? void 0 : ref.retrieved_on) || moment_default()();
    var companyIcon = (ref1 = currentPost[0]) === null || ref1 === void 0 ? void 0 : ref1.company_icon_url;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, {
        visible: visible,
        centered: true,
        footer: null,
        width: "520px",
        onCancel: onCancel,
        destroyOnClose: destroyOnClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: isLoading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loading, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
                condition: !isLoading,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        justify: "center",
                        mb: "24px",
                        mt: "18px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: "/icon/announcement.svg",
                            alt: "announcement icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        mb: "8px",
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            size: "18px",
                            family: "bold",
                            align: "center",
                            style: {
                                maxWidth: "85%"
                            },
                            children: (ref2 = currentPost[0]) === null || ref2 === void 0 ? void 0 : ref2.headline
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        height: "19px",
                        mb: "24px",
                        align: "center",
                        children: moment_default()(postedDate).format("DD MMMM YYYY, HH:mm")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/symbol/".concat((ref3 = currentPost[0]) === null || ref3 === void 0 ? void 0 : ref3.symbol),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            style: {
                                color: "unset"
                            },
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* AnnouncementCompanyCard */.Ih, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* AnnouncementCompanyCardIcon */.J5, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                condition: companyIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                    src: (ref4 = currentPost[0]) === null || ref4 === void 0 ? void 0 : ref4.company_icon_url
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                                                condition: !companyIcon,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* SymbolErrorIcon */.YZ, {
                                                    children: (ref7 = (ref5 = currentPost[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.symbol) === null || ref6 === void 0 ? void 0 : ref6.toUpperCase()) === null || ref7 === void 0 ? void 0 : ref7.slice(0, 1)
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                        direction: "column",
                                        style: {
                                            gap: "2px",
                                            flex: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                size: "16px",
                                                height: "15px",
                                                family: "bold",
                                                children: (ref8 = currentPost[0]) === null || ref8 === void 0 ? void 0 : ref8.symbol
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                height: "15px",
                                                color: color/* default.highgray */.Z.highgray,
                                                children: (ref9 = currentPost[0]) === null || ref9 === void 0 ? void 0 : ref9.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                        align: "center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                            src: "/icon/chevron-right-gray.svg"
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    currentPost.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            marginTop: "16px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AnnouncementAttachmentLabel */.EL, {
                                color: color/* default.highgray */.Z.highgray,
                                children: "Attachment:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* AttachmentList */.fU, {
                                children: currentPost.map(function(report) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: report.attachment,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                                padding: "8px 0",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                                        src: "/icon/announcement-report.svg",
                                                        alt: "icon file",
                                                        width: "24",
                                                        height: "20"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                                        size: "14px",
                                                        height: "18.9px",
                                                        padding: "0 12px",
                                                        children: report.title
                                                    })
                                                ]
                                            })
                                        })
                                    }, report.name);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Modals_ModalAnnouncement = (ModalAnnouncement);

// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
// EXTERNAL MODULE: ./src/global/StreamWidget/utils.ts
var utils = __webpack_require__(11237);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/TitleContent.tsx







function TitleContent(param) {
    var title = param.title, titleUrl = param.titleUrl, highlightWord = param.highlightWord;
    var ref = (0,react.useState)(false), showModal = ref[0], setShowModal = ref[1];
    var textRef = (0,react.useRef)(null);
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var handleOpenLink = function(e) {
        e.preventDefault();
        var isExternalLink = titleUrl.indexOf("://") > -1;
        if (isExternalLink) {
            window.open(titleUrl, "_blank");
        } else if (isLoggedIn) {
            setShowModal(true);
        } else {
            window.location.href = "/register";
        }
    };
    (0,react.useEffect)(function() {
        if (!(textRef === null || textRef === void 0 ? void 0 : textRef.current)) {
            return;
        }
        if (highlightWord) {
            (0,utils/* highlightWords */.zk)(highlightWord, textRef.current, "mark");
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* Title */.Dx, {
                // @ts-expect-error
                ref: textRef,
                href: titleUrl,
                onClick: handleOpenLink,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_ModalAnnouncement, {
                url: titleUrl,
                visible: showModal,
                destroyOnClose: true,
                onCancel: function() {
                    return setShowModal(false);
                }
            })
        ]
    });
}
/* harmony default export */ var Post_TitleContent = (TitleContent);


/***/ }),

/***/ 57543:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Post_WarningBadge; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./src/global/StreamWidget/constants.ts
var constants = __webpack_require__(21390);
// EXTERNAL MODULE: ./src/global/Moderation/Modals/styled.js
var styled = __webpack_require__(74673);
;// CONCATENATED MODULE: ./src/global/Moderation/Modals/ModalWarning.tsx







var ModalWarning = function(param) {
    var onSubmit = param.onSubmit, visible = param.visible, onCancel = param.onCancel;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Modal */.u_, {
        onCancel: onCancel,
        visible: visible,
        centered: true,
        width: 480,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "center",
                style: {
                    marginBottom: "20px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    src: "/images/SpamWarning.svg",
                    width: 180,
                    height: 135,
                    alt: "Post Warning"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "center",
                size: "18px",
                weight: 700,
                color: color/* default.highempahis */.Z.highempahis,
                style: {
                    marginBottom: "12px"
                },
                children: "Content Warning"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                align: "center",
                size: "14px",
                color: "#858585",
                style: {
                    marginBottom: "32px"
                },
                children: constants/* warningContent */.Lv
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                block: true,
                height: "44px",
                radius: "4px",
                onClick: onSubmit,
                danger: true,
                ghost: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    weight: "700",
                    color: color/* default.sunsetOrange */.Z.sunsetOrange,
                    children: "Report"
                })
            })
        ]
    });
};
/* harmony default export */ var Modals_ModalWarning = (ModalWarning);

// EXTERNAL MODULE: ./src/@deprecated-ui/common/index.js + 5 modules
var common = __webpack_require__(48308);
// EXTERNAL MODULE: ./src/global/StreamWidget/Post/styled.ts
var Post_styled = __webpack_require__(97986);
;// CONCATENATED MODULE: ./src/global/StreamWidget/Post/WarningBadge.tsx









var WarningBadge = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, modalReport = param.modalReport, showModalReport = param.showModalReport, modalWarning = param.modalWarning, setModalWarning = param.setModalWarning;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(If/* default */.Z, {
        condition: visible,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Tooltip */.u, {
                placement: "bottomRight",
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0,
                arrowPointAtCenter: true,
                overlayClassName: "stream-label-tooltip",
                title: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            align: "center",
                            style: {
                                gap: 4
                            },
                            margin: "0 0 4px 0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/images/day-trade/info-danger.svg",
                                    alt: "Info",
                                    height: "20",
                                    width: "20"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Text */.xv, {
                                    color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                    size: "14px",
                                    weight: "700",
                                    children: "Content Warning"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Text */.xv, {
                            color: color/* default.lowgray */.Z.lowgray,
                            align: "justify",
                            size: "12px",
                            weight: "400",
                            children: constants/* warningContent */.Lv
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Post_styled/* UnstyledButton */.kG, {
                    onClick: function() {
                        return setModalWarning(true);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Post_styled/* BadgeJunk */.Iw, {
                        type: "spam",
                        visible: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/day-trade/info-danger.svg",
                                alt: "Info",
                                height: "20",
                                width: "20"
                            }),
                            "Warning"
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modals_ModalWarning, {
                onSubmit: function() {
                    return showModalReport(true);
                },
                visible: modalWarning && !modalReport,
                onCancel: function() {
                    return setModalWarning(false);
                }
            })
        ]
    });
};
/* harmony default export */ var Post_WarningBadge = (WarningBadge);


/***/ }),

/***/ 74132:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_youtube__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5406);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33082);
/* harmony import */ var react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_stream__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97986);






function YoutubePlayer(param) {
    var content = param.content, _autoplay = param.autoplay, autoplay = _autoplay === void 0 ? true : _autoplay, _dataCyName = param.dataCyName, dataCyName = _dataCyName === void 0 ? "" : _dataCyName;
    var playerRef = (0,react__WEBPACK_IMPORTED_MODULE_4__.useRef)();
    var youtubeUrl = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .getYoutubeURL */ .Zu)(content);
    var youtubeId = (0,utils_stream__WEBPACK_IMPORTED_MODULE_3__/* .getYoutubeVideoId */ .P9)(youtubeUrl);
    var youtubeOptions = {
        width: "100%",
        playerVars: {
            autoplay: 0,
            mute: 1
        }
    };
    var handleChangeVisibility = function(isVisible) {
        if (autoplay) {
            if (isVisible && playerRef) {
                var // @ts-ignore
                ref, ref1;
                playerRef === null || playerRef === void 0 ? void 0 : (ref = playerRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.internalPlayer) === null || ref1 === void 0 ? void 0 : ref1.playVideo();
            } else {
                var // @ts-ignore
                ref2, ref3;
                playerRef === null || playerRef === void 0 ? void 0 : (ref2 = playerRef.current) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.internalPlayer) === null || ref3 === void 0 ? void 0 : ref3.pauseVideo();
            }
        }
    };
    if (youtubeId) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_visibility_sensor__WEBPACK_IMPORTED_MODULE_2___default()), {
            onChange: handleChangeVisibility,
            minTopValue: 100,
            scrollCheck: true,
            scrollDelay: 1000,
            intervalDelay: 2000,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .YoutubeWrapper */ .fj, {
                "data-cy": dataCyName,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_youtube__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                    videoId: youtubeId,
                    opts: youtubeOptions,
                    ref: playerRef
                })
            })
        });
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (YoutubePlayer);


/***/ }),

/***/ 18278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ge": function() { return /* binding */ DATA_CY_POST_GUEST_FOOTER_REPLIES; },
/* harmony export */   "H9": function() { return /* binding */ DATA_CY_FOOTER_SHARE_BUTTON_COMPANY; },
/* harmony export */   "Hc": function() { return /* binding */ DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY; },
/* harmony export */   "KL": function() { return /* binding */ DATA_CY_FOOTER_LIKE_BUTTON_COMPANY; },
/* harmony export */   "On": function() { return /* binding */ DATA_CY_FOOTER_SHARE_BUTTON; },
/* harmony export */   "RN": function() { return /* binding */ DATA_CY_POST_GUEST_FOOTER_DISLIKES; },
/* harmony export */   "Vi": function() { return /* binding */ DATA_CY_STREAM_COMMENT_ICON; },
/* harmony export */   "bP": function() { return /* binding */ DATA_CY_STREAM_ITEM_OPTION_BUTTON; },
/* harmony export */   "dJ": function() { return /* binding */ DATA_CY_STREAM_COMMENT_ICON_COMPANY; },
/* harmony export */   "hl": function() { return /* binding */ DATA_CY_POST_GUEST_FOOTER_LIKES; },
/* harmony export */   "l": function() { return /* binding */ DATA_CY_FOOTER_LIKE_BUTTON; },
/* harmony export */   "lV": function() { return /* binding */ DATA_CY_POST_STREAM_ITEM_OPTION; },
/* harmony export */   "nS": function() { return /* binding */ DATA_CY_POST_GUEST_FOOTER; },
/* harmony export */   "q2": function() { return /* binding */ DATA_CY_POST_GUEST_FOOTER_SHARES; },
/* harmony export */   "tJ": function() { return /* binding */ DATA_CY_FOOTER_TIP_BUTTON_COMPANY; },
/* harmony export */   "vI": function() { return /* binding */ DATA_CY_FOOTER_TIP_BUTTON; }
/* harmony export */ });
var DATA_CY_FOOTER_LIKE_BUTTON = "footer-like-button";
var DATA_CY_FOOTER_SHARE_BUTTON = "footer-share-button";
var DATA_CY_FOOTER_TIP_BUTTON = "footer-tip-button";
var DATA_CY_FOOTER_LIKE_BUTTON_COMPANY = "company-footer-like-button";
var DATA_CY_FOOTER_SHARE_BUTTON_COMPANY = "company-footer-share-button";
var DATA_CY_FOOTER_TIP_BUTTON_COMPANY = "company-footer-tip-button";
var DATA_CY_STREAM_ITEM_OPTION_BUTTON = "stream-item-option-button";
var DATA_CY_STREAM_ITEM_OPTION_BUTTON_COMPANY = "stream-item-option-button_company";
var DATA_CY_STREAM_COMMENT_ICON = "stream-comment-icon";
var DATA_CY_STREAM_COMMENT_ICON_COMPANY = "company-stream-comment-icon";
// Guest Footer
var DATA_CY_POST_GUEST_FOOTER = "post-guest-footer";
var DATA_CY_POST_GUEST_FOOTER_LIKES = "post-guest-footer-likes";
var DATA_CY_POST_GUEST_FOOTER_DISLIKES = "post-guest-footer-dislikes";
var DATA_CY_POST_GUEST_FOOTER_REPLIES = "post-guest-footer-replies";
var DATA_CY_POST_GUEST_FOOTER_SHARES = "post-guest-footer-shares";
// Stream Item Option
var DATA_CY_POST_STREAM_ITEM_OPTION = "post-stream-item-option";


/***/ }),

/***/ 18562:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreamWidget_TargetPriceContainer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/utils.ts
var utils = __webpack_require__(24293);
// EXTERNAL MODULE: ./src/features/securities/AuthModal/constants.ts
var constants = __webpack_require__(54855);
// EXTERNAL MODULE: ./src/features/ifa/hooks/index.ts + 1 modules
var hooks = __webpack_require__(63693);
// EXTERNAL MODULE: ./src/features/ifa/stores/modal.store.ts
var modal_store = __webpack_require__(46553);
// EXTERNAL MODULE: ./src/global/StreamWidget/slice/index.tsx + 2 modules
var slice = __webpack_require__(47225);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/global/StreamWidget/TargetPriceContainer/constants.ts

var targetPriceType = {
    bearish: {
        text: "Downside",
        color: color/* default.sunsetOrange */.Z.sunsetOrange
    },
    bullish: {
        text: "Upside",
        color: color/* default.primary */.Z.primary
    }
};
// eslint-disable-next-line import/prefer-default-export


;// CONCATENATED MODULE: ./src/global/StreamWidget/TargetPriceContainer/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  border: 1px solid ",
        ";\n  border-left: 6px solid\n    ",
        ";\n  padding: 20px 15px 20px 23px;\n  margin-top: 16px;\n  margin-bottom: 16px;\n  border-radius: 3px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-top: 1px solid ",
        ";\n  width: fit-content;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    position: absolute;\n    left: 10px;\n    top: 10px;\n    height: 24px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 60px;\n  border: 1px solid ",
        ";\n  border-radius: 3px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 50%;\n  height: 100%;\n  background: ",
        ";\n  :last-child {\n    border-left: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}






var TargetPriceWrapper = styled_components_browser_esm/* default.div.attrs */.ZP.div.attrs(function(props) {
    return {
        targetType: props.targetType
    };
}).withConfig({
    componentId: "sc-d6432de5-0"
})(_templateObject(), color/* default.gainsboro */.Z.gainsboro, function(param) {
    var targetType = param.targetType;
    return targetPriceType[targetType].color;
});
var TextBorder = (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).attrs({
    size: "12px",
    padding: "2px 0"
}).withConfig({
    componentId: "sc-d6432de5-1"
})(_templateObject1(), color/* default.highempahis */.Z.highempahis);
var ButtonVote = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    height: "45px",
    block: true,
    round: true
}).withConfig({
    componentId: "sc-d6432de5-2"
})(_templateObject2());
var ResultWrapper = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-d6432de5-3"
})(_templateObject3(), color/* default.silver */.Z.silver);
var Result = (0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).attrs(function(props) {
    return {
        background: props.background || color/* default.light */.Z.light,
        direction: "column",
        justify: "center",
        align: "center"
    };
}).withConfig({
    componentId: "sc-d6432de5-4"
})(_templateObject4(), function(param) {
    var background = param.background;
    return background;
}, color/* default.silver */.Z.silver);


;// CONCATENATED MODULE: ./src/global/StreamWidget/TargetPriceContainer/index.tsx
















function TargetPriceContainer(param) {
    var targetPrice = param.targetPrice, postid = param.postid, isAuthor = param.isAuthor;
    var dispatch = (0,es/* useDispatch */.I0)();
    var showAdvisorModal = (0,hooks/* useLinkedToAdvisor */.m)();
    // select data from slice
    var postVoteTargetPrice = (0,es/* useSelector */.v9)(slice/* selectors */.wl).postVoteTargetPrice;
    var isLoading = postVoteTargetPrice.isLoading;
    // price gap
    var duration = targetPrice.duration, id = targetPrice.id, tradeable = targetPrice.tradeable, voted = targetPrice.voted, dayLeft = targetPrice.day_left, last = targetPrice.last_price, target = targetPrice.target_price;
    var isHit = targetPrice.hit === 1;
    var isMissed = targetPrice.hit === 2;
    var canBuy = targetPrice.hit === 0 && tradeable === 1;
    var isFinished = isHit || isMissed || dayLeft <= 0;
    var differentPercentage = (target - last) / last * 100;
    var targetType = differentPercentage < 0 ? "bearish" : "bullish";
    // vote percentage
    var agree = targetPrice.agree, disagree = targetPrice.disagree;
    var totalVote = agree + disagree;
    var agreePercentage = agree / totalVote * 100;
    var disagreePercentage = disagree / totalVote * 100;
    var votedValueMapper = {
        agree: 1,
        disagree: 0
    };
    var handleVoteTargetPrice = function(agreeVal) {
        var data = {
            targetPriceId: id,
            agree: votedValueMapper[agreeVal],
            postid: postid
        };
        dispatch(slice/* effects.postVoteTargetPrice */.Sz.postVoteTargetPrice(data));
    };
    var handleClickButtonBuy = function() {
        if (showAdvisorModal) {
            modal_store/* default.getState */.Z.getState().openModal(modal_store/* ModalNames.PORTFOLIO_MANAGED_BY_ADVISOR */.s.PORTFOLIO_MANAGED_BY_ADVISOR);
            return;
        }
        (0,utils/* showTradingModalWithAuth */.Y)({
            symbol: targetPrice.symbol2 || targetPrice.symbol,
            orderType: constants/* AUTH_ORDER_TYPE.BUY */.q.BUY
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TargetPriceWrapper, {
        "data-cy": "stream-target-price",
        targetType: targetType,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "10px",
                                children: [
                                    "MY ",
                                    targetType.toUpperCase(),
                                    " PREDICTION"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "center",
                                wrap: "wrap",
                                padding: "0 10px 0 0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: "600",
                                        family: "bold",
                                        height: "30px",
                                        size: "22px",
                                        padding: "5px 5px 2px 0",
                                        children: targetPrice.symbol2 || targetPrice.symbol
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        color: color/* default.heather */.Z.heather,
                                        children: targetPrice.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                align: "flex-end",
                                margin: "15px 0",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        weight: "600",
                                        family: "bold",
                                        height: "38px",
                                        size: "38px",
                                        padding: "5px 5px 2px 0",
                                        children: numeral_default()(targetPrice.target_price).format("0,0")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                        height: "38px",
                                        style: {
                                            whiteSpace: "nowrap"
                                        },
                                        children: "Target Price"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isHit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "",
                                src: "https://stockbit.com/assets/img/correct.png",
                                style: {
                                    width: "80px"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: isMissed,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                alt: "",
                                src: "https://stockbit.com/assets/img/missed.png",
                                style: {
                                    width: "80px"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: canBuy,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                width: "100px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                "data-cy": "stream-target-price-buy",
                                type: "primary",
                                // @ts-expect-error
                                round: true,
                                block: true,
                                onClick: handleClickButtonBuy,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    size: "18px",
                                    color: color/* default.light */.Z.light,
                                    align: "center",
                                    children: "BUY"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justify: "space-between",
                padding: "0 20px 20px 0",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBorder, {
                                children: "Initial Price"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                children: numeral_default()(targetPrice.last_price).format("0,0")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBorder, {
                                children: targetPriceType[targetType].text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                color: targetPriceType[targetType].color,
                                children: [
                                    numeral_default()(differentPercentage).format("0.00"),
                                    "%"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBorder, {
                                children: "Timing"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                children: [
                                    "".concat(duration, " days"),
                                    " ",
                                    isFinished ? "(Finished)" : "(".concat(dayLeft, " day").concat(dayLeft > 1 ? "s" : "", " left)")
                                ]
                            })
                        ]
                    })
                ]
            }),
            voted !== "" || isFinished || isAuthor ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResultWrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Result, {
                        background: voted === "disagree" && color/* default.coralCandy */.Z.coralCandy,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                align: "center",
                                size: "16px",
                                weight: "600",
                                family: "bold",
                                color: color/* default.sunsetOrange */.Z.sunsetOrange,
                                children: [
                                    numeral_default()(disagreePercentage).format("0,0"),
                                    "% Disagree"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "12px",
                                color: color/* default.dimgray */.Z.dimgray,
                                align: "center",
                                padding: "3px",
                                children: [
                                    targetPrice.disagree,
                                    " votes"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Result, {
                        background: voted === "agree" && color/* default.hummingBird */.Z.hummingBird,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                align: "center",
                                size: "16px",
                                weight: "600",
                                family: "bold",
                                color: color/* default.primary */.Z.primary,
                                children: [
                                    numeral_default()(agreePercentage).format("0,0"),
                                    "% Agree"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                size: "12px",
                                color: color/* default.dimgray */.Z.dimgray,
                                align: "center",
                                padding: "3px",
                                children: [
                                    targetPrice.agree,
                                    " votes"
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "50%",
                            paddingRight: "5px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonVote, {
                            type: "bearish",
                            disabled: isLoading,
                            round: true,
                            onClick: function() {
                                return handleVoteTargetPrice("disagree");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "",
                                    src: "https://stockbit.com/assets/img/stpdown.png"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    align: "center",
                                    children: "Disagree"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            width: "50%",
                            paddingLeft: "5px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonVote, {
                            disabled: isLoading,
                            type: "bullish",
                            round: true,
                            onClick: function() {
                                return handleVoteTargetPrice("agree");
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    alt: "",
                                    src: "https://stockbit.com/assets/img/stpup.png"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    align: "center",
                                    children: "Agree"
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var StreamWidget_TargetPriceContainer = (TargetPriceContainer);


/***/ }),

/***/ 20072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78372);
/* harmony import */ var constants_api__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37213);
/* eslint-disable camelcase */ /** @typedef {import('../../../@types/api-response').APIResponse} APIResponse */ 

var requestExodus = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaultInstance */ .Z.defaultInstance;
var requestExodusNoAlert = lib_api_instances_exodus__WEBPACK_IMPORTED_MODULE_0__/* ["default"].noAlert */ .Z.noAlert;
// URLs aliases
var TIPPING_EXODUS_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
// EXODUS TIPPING URL
var EXODUS_TIPPING_URL = "".concat(constants_api__WEBPACK_IMPORTED_MODULE_1__/* .API_EXODUS_URL */ .q7, "/tip");
/**
 * @return {APIResponse}
 */ var getTippingJar = function() {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/jar"));
};
/**
 * Send tipping from stream
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTippingStream = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/**
 * Claim tipping balance
 * @param {number} amount - Amount to be claimed
 * @return {APIResponse}
 */ var claimTippingBalance = function(amount) {
    return requestExodus.post("".concat(TIPPING_EXODUS_URL, "/claim"), {
        amount: amount
    });
};
/**
 * Update gopay account by number for tipping
 * @param {string} account - Account number
 * @return {APIResponse}
 */ var updateGopayAccount = function(account) {
    return requestExodus.patch("".concat(EXODUS_TIPPING_URL, "/gopay-account"), {
        gopay_account: account
    });
};
/**
 * Get detail tipping from notif
 * @param {string | number} tippingId
 * @return {APIResponse}
 */ var getTippingDetail = function(tippingId) {
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/detail/").concat(tippingId));
};
var getTippingActivity = function() {
    var tabActivity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "TIP_TAB_TIPPING";
    return requestExodusNoAlert.get("".concat(EXODUS_TIPPING_URL, "/activity"), {
        params: {
            tab: tabActivity
        }
    });
};
/**
 * Send tipping
 * @param {Object} tipData
 * @param {Object} tipData.tipable - Target tip
 * @param {number} tipData.tipable.id - Target tip id
 * @param {Object} tipData.tipable.type - Target tip
 * @param {number} tipData.amount - Amount given
 * @param {string=} tipData.message - Additional message
 * @param {string=} tipData.callback_url - Additional message
 * @return {APIResponse}
 */ var sendTipping = function(tipData) {
    return requestExodus.post(TIPPING_EXODUS_URL, tipData);
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    getTippingJar: getTippingJar,
    getTippingDetail: getTippingDetail,
    sendTippingStream: sendTippingStream,
    claimTippingBalance: claimTippingBalance,
    updateGopayAccount: updateGopayAccount,
    getTippingActivity: getTippingActivity,
    sendTipping: sendTipping
});


/***/ }),

/***/ 98585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sz": function() { return /* binding */ effects; }
/* harmony export */ });
/* unused harmony export selector */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68697);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61876);
/* harmony import */ var lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20072);



// APIs

// Initial state
var initialState = {
    detail: {},
    data: {},
    isLoading: false,
    error: null,
    message: ""
};
// Selectors
var selector = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)(function(state) {
    return state.entities.tipping;
}, function(tipping) {
    return {
        data: tipping.data,
        isLoading: tipping.isLoading,
        error: tipping.error,
        detail: tipping.detail
    };
});
// Action types
var CONTEXT = "@redux/entities";
var actionType = {
    GET_TIPPING_JAR: "".concat(CONTEXT, "/GET_TIPPING_JAR"),
    CLAIM_TIPPING_BALANCE: "".concat(CONTEXT, "/CLAIM_TIPPING_BALANCE"),
    SEND_TIPPING: "".concat(CONTEXT, "/SEND_TIPPING"),
    UPDATE_GOPAY_ACCOUNT: "".concat(CONTEXT, "/UPDATE_GOPAY_ACCOUNT"),
    GET_TIPPING_DETAIL: "".concat(CONTEXT, "/GET_TIPPING_DETAIL"),
    SEND_TIPPING_GENERAL: "".concat(CONTEXT, "/SEND_TIPPING_GENERAL")
};
// Effects
var effects = {
    sendTipping: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTippingStream */ .Z.sendTippingStream(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }()),
    sendTippingGeneral: (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createAsyncThunk */ .hg)(actionType.SEND_TIPPING_GENERAL, function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(tipData) {
            var response, _data, _$error, message, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_tipping__WEBPACK_IMPORTED_MODULE_1__/* ["default"].sendTipping */ .Z.sendTipping(tipData);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Attempt to send tip failed");
                    case 6:
                        _data = response.data, _$error = _data.error, message = _data.message, data = _data.data;
                        if (!_$error) {
                            _ctx.next = 9;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            error: _$error,
                            message: message
                        });
                    case 9:
                        return _ctx.abrupt("return", {
                            data: data,
                            message: message
                        });
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](0);
                        return _ctx.abrupt("return", {
                            error: _ctx.t0
                        });
                    case 15:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    12
                ]
            ]);
        }));
        return function(tipData) {
            return _ref.apply(this, arguments);
        };
    }())
};
// Reducers
var reducers = {};
var extraReducers = {
};
var tipping = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_3__/* .createSlice */ .oM)({
    name: "tipping",
    initialState: initialState,
    reducers: reducers,
    extraReducers: extraReducers
});
/* harmony default export */ __webpack_exports__["ZP"] = (tipping);


/***/ }),

/***/ 9486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ getAnalyticsPageSource; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable import/prefer-default-export */ 
/**
 * get page source for analytics, please check this function before use it;
 */ function getAnalyticsPageSource() {
    var path = (next_router__WEBPACK_IMPORTED_MODULE_0___default().pathname);
    switch(path){
        case "/stream":
            return "Stream";
        case "/[username]":
            return "Profile";
        case "/symbol/[symbol]":
            return "Company";
        default:
            return null;
    }
}



/***/ })

}]);